export const en_US = {
    "LOADER": {
        "LOAD-USER-DATA": "Loading candidate data",
        "CHECK-PRE-EXISTING-RESPONSE": "Checking for pre-existing response",
        "INIT-PRE-EXISTING-DISK": "Loading pre-existing response from disk",
        "INIT-PRE-EXISTING-HYBRID": "Loading pre-existing response from the internet",
        "INIT-NEW-RESPONSE": "Starting new response"
    },
    "MODULES": {
        "ADMIN": {
            "HEADLINE": "Invigilator Menu",
            "QUIT-HEADLINE": "End examination",
            "QUIT-EARLY-HEADLINE": "Leave package",
            "LEGEND": {
                "ADMIN": "Administration",
                "IAA": "Inclusive Assessment arrangements",
                "LOG": "Log"
            },
            "LABEL": {
                "PAUSE": "Candidate can pause",
                "FONT": "Alternative accessible font",
                "ZOOM": "Zoom level",
                "COLOR": "Colour theme",
                "VIDEO": "Video subtitle auto-enable",
                "RESUME": "Invigilator code required to resume?",
                "REASON": "Reason",
                "TYPE": "Type",
                "EXTRA-TOTAL-TIME": "Additional minutes:",
                "CANDIDATE-TOTAL-TIME-LABEL": "Candidate total time:",
                "CANDIDATE-TOTAL-TIME": "{{totalTimeAvailableFormatted }} ({{timeElapsed }} elapsed; {{timeLeft}} remaining)",
                "NEW-CANDIDATE-TOTAL-TIME-LABEL": "New total time:",
                "NEW-CANDIDATE-TOTAL-TIME": "{{newTotalTimeAvailableFormatted}}",
                "EXPLANATION": "Explanation",
                "FOCUS_LOST-EXPLANATION": "Explanation",
                "FOCUS_LOST-EXPLANATION-MIN-CHAR": "({{s}} characters minimum)",
                "EXPLANATION-MIN-CHAR":"({{s}} characters minimum)",
                "INVIGILATOR-UNLOCK-CODE": "Invigilator code",
                "COLOR-THEMES": "Colour - Themes"
            },
            "REASON-PLACEHOLDER": "You may enter an explanatory note here",
            "REASON-PLACEHOLDER-MANDATORY": "You may enter an explanatory note here",
            "INVIGILATOR_UNLOCK_NOTE": "Please enter an invigilator code and then click <strong>Unlock</strong>",
            "ERROR": {
                "UNLOCKFAILED": "Incorrect invigilator code entered"
            },
            "EVENTLOG_INVIGILATOR_UNLOCK_SUCCESS": "Invigilator opened the Invigilator Menu",
            "EVENTLOG_INVIGILATOR_UNLOCK_FAILED": "Incorrect invigilator code entered",
            "EVENTLOG_APPLICATION_FOCUS_LOST_INVIGILATOR_UNLOCK_SUCCESS": "Application focus lost. Invigilator code successful",
            "EVENTLOG_APPLICATION_FOCUS_LOST_INVIGILATOR_UNLOCK_FAILED": "Application focus lost. Incorrect invigilator code entered",
            "EVENTLOG_INVIGILATOR_UNLOCK_EMPTY": "This field cannot be left blank!",
            "EVENTLOG_APPLICATION_FOCUS_LOST": "Application focus lost for {{sec}} seconds",
            "EVENTLOG_APPLICATION_FOCUS_LOST_SHORT": "Focus lost Short {{time}} time for {{sec}} seconds",
            "EVENTLOG_APPLICATION_FOCUS_LOST_OVER_THRESHOLD": "Focus lost short over Threshold, {} times",
            "EVENTLOG_APPLICATION_MULTI_FOCUS_LOST": "Application focus lost {{time}} times for {{sec}} seconds",
            "EVENTLOG_APPLICATION_FOCUS_LOST_DIALOG": "Application focus lost dialog for {{sec}} seconds",
            "EVENTLOG_APPLICATION_FOCUS_LOST_DIALOG_EXPIRED": "Application focus lost dialog close after exprired for {{sec}} seconds",
            "EVENTLOG_APPLICATION_RESUME_BY_CANDIDATE": "Examination resumed by candidate",
            "EVENTLOG_APPLICATION_RESUME_BY_INVIGILATOR": "Examination resumed by invigilator",
            "EVENTLOG_EXTRATIME_DEDUCTED": "{{deducted}} minutes deducted. New total time: {{new_total_time}}",
            "EVENTLOG_EXTRATIME_ADD": "{{add}} minutes added. New total time: {{new_total_time}}",
            "EVENTLOG_PAUSE_INVIGILATOR_MENU":"Paused for Invigilator Menu access",
            "EVENTLOG_PAUSE_BY_INVIGILATOR":"Invigilator paused the examination",
            "EVENTLOG_PAUSE_BY_CANDIDATE":"Candidate paused the examination",
            "EVENTLOG_FINISH_EARLY_BY_INVIGILATOR": "Finish Early by Invigilator",
            "EVENTLOG_LEAVE_PACKAGE_BY_INVIGILATOR": "Leave package by Invigilator",
            "PAUSE": {
                "HEADLINE": "Paused",
                "CONTENT": [
                    "The examination has been paused.",
                    "An invigilator code is required to resume.",
                    "To resume the examination, press the button below."
                ]
            },
            "ENTERED-CHAR":"{{s}} of max 4000 characters entered",
            "ENTERED-CHAR-EMPTY":"0 characters entered",
            "QUIT-CONTENT":[
                    "Are you sure you want to end the examination?"
                ],
            "QUIT-EARLY-CONTENT":[
                "WARNING! This option should only be used if technical difficulties are being experienced, which may be rectified by leaving the package and logging back in again.<br/><br/>",
                "A response file will NOT be prepared/processed, which will allow the candidate to log back in to the package and continue their examination from their current position.<br/><br/>",
                "If you simply wish to end the examination (as the candidate has finished early), please select <strong>Cancel</strong> and choose to <strong>End Examination</strong> instead, which will produce a final response file.<br/><br/>",
                "Do you still wish to proceed? If so, please confirm by clicking the <strong>Leave package</strong> button."
            ],
            "QUIT-EARLY-CONTENT-ISSUE":[
                "WARNING! Technical difficulties have occurred, which may be rectified by leaving the package and logging back in again.<br/><br/>",
                "A response file will NOT be prepared/processed, which will allow the candidate to log back in to the package and continue their examination from their current position.<br/><br/>",
            ],
            "QUIT-EARLY-CONFIRM": "Leave package",
            "MODAL": {
                "HEADLINE": {
                    "CANDIDATE-PAUSE"               : "Pause",
                    "CANDIDATE-CAN-PAUSE-ACTIVATE"  : "Candidate can pause (Activate)",
                    "CANDIDATE-CAN-PAUSE-DEACTIVATE": "Candidate can pause (Deactivate)",
                    "EXTRA-TIME"                    : "Additional time",
                    "VIDEO-SUBTITLE-ACTIVATE"       : "Video subtitle auto-enable (Activate)",
                    "VIDEO-SUBTITLE-DEACTIVATE"     : "Video subtitle auto-enable (Deactivate)"
                }
            },
            "INACTIVITY-TIMEOUT": {
                "HEADER": "Inactivity timeout",
                "ASSESSMENT-RUNNING": {
                    "CONTENT": [
                        "You have not interacted with the examination for 10 minutes. You may <strong>Continue</strong> or <strong>Reset time</strong>.<br><br>Alternatively, you can choose to <strong>End examination</strong>."
                    ],
                    "FINISH-EARLY": "Do you really want to quit? This will end the examination."
                },
                "ASSESSMENT-EXPIRED": {
                    "CONTENT": "You have not interacted with the examination for 10 minutes. The examination has now ended.",
                    "JOURNAL-EXITS": "Do you want to complete the Journal?"
                },
                "UNLOCK-INFO": [
                    "You have chosen to reset time to the point of the last interaction: <strong>{{s}}</strong>.<br><br>",
                    "To proceed, please enter your invigilator code and click <strong>Confirm</strong>.<br><br>",
                    "Alternatively, you may still choose <strong>Continue</strong> to return to the examination."
                ],
                "UNLOCK-INFO-END-EXAM": "Please enter an invigilator code to end the examination.",
                "UNLOCK-PLACEHOLDER": "Invigilator code",
                "RESTART": "To resume examination from <strong>{{s}}</strong>, please <strong>Confirm restart</strong>.",
                "EXPLANATION-PLACEHOLDER": "You may write an explanatory note here.",
                "EXPLANATION": "Explanation",
                "EXPLANATION-MIN-CHAR": "({{s}} characters minimum)",
                "LOG": {
                    "INACTIVITY-TIMEOUT-START": "Inactivity timeout start",
                    "INACTIVITY-TIMEOUT-RESET": "Reset time after inactivity timeout",
                    "FINISH-EARLY-BY-INVIGILATOR": "Finish examination early by invigilator"
                }
            }
        },
        "WELCOME": {
            "HEADLINE": "Welcome to your MYP on-screen examination <br>",
            "HEADLINE-MEDIA": "Welcome to the Diploma Programme music audio package <br>",
            "ISEXPIRED": "This examination package has now expired; it was valid until:<br><strong>{{expire_date|amDateFormat:'MMMM Do YYYY, HH:mm'}}</strong>",
            "ISBEGUN": "This examination package is not yet accessible; it can be accessed from:<br><strong>{{begin_date|amDateFormat:'MMMM Do YYYY, HH:mm'}}</strong>",
            "CONTENT": [
                "<em>Permission to reproduce content where third-party owned material protected by copyright is included has been sought and cleared where necessary, and where possible. Reasonable effort has been made to trace copyright holders, but if any items requiring clearance have unwittingly been included, we will be pleased to make amends at the earliest opportunity. Any trademarks™ or registered® trademarks included are used for illustrative purposes only, and use does not imply any affiliation with or endorsement by the International Baccalaureate.</em>",
                "<em>For assessment purposes, all acknowledgements of third-party material are stored and published separately.<br><br>The IB takes no responsibility and will not be liable for any technical issues (or otherwise) beyond its control or for any loss or damage suffered as a result of the use of or access to the platform from personal computers or computers other than school devices.</em>"
            ],
            "SECONDARY_ACCESS_CODE": "Enter secondary access code",
            "SECONDARY_ACCESS_CODE_ERROR": "You have entered an invalid access code.",
            "INVIGILATOR_LOGIN": "Invigilator login"
        },
        "PWA-START": {
            "OPEN": "Open",
            "SCAN-QR-CODE": "Scan QR Code",
            "PACKAGE-TYPE-SPECIMEN": "specimen",
            "PACKAGE-TYPE-SCHOOL": "live exam",
            "VALID-FROM-TO": "Valid from {{valid_from|amDateFormat:'MMMM Do YYYY, HH:mm'}} to {{valid_to|amDateFormat:'MMMM Do YYYY, HH:mm'}}",
            "NOT-AVAILABLE": "Not Available",

            "LOADING-ASSESSMENTS": "Loading assessments...",

            "FIRST-TIME-MESSAGE-1": "This is the first time you have used this app. You have not yet loaded any assessments.",
            "FIRST-TIME-MESSAGE-2": "In order to load an assessment, you need to acquire a QR code for an assessment package.",
            "FIRST-TIME-MESSAGE-3": "If you have a QR code, you can scan it by clicking the \"Scan QR Code\" button below.",

            "NO-ASSESSMENTS": "No assessments are currently stored.",

            "QR-HEADLINE": "Scan QR Code",
            "QR-CANCEL": "Cancel",

            "DOWNLOADING-ASSESSMENT": "Downloading Assessment...",
            "DOWNLOADED-ASSESSMENT": "Downloaded Assessment",
            "UNPACKING-ASSESSMENT": "Unpacking Assessment...",
            "ASSESSMENT-READY": "Assessment Ready",
            "ASSESSMENT-READY-MESSAGE": "The assessment has been downloaded and unpacked successfully.",
            
            "RETRY-DOWNLOAD": "Retry Download",
            "TRY-ANOTHER-QR-CODE": "Try Another QR Code",
            "ERROR-MESSAGE": "Error",
            "ERROR-404": "Assessment package not found (Error {{error_code}}). This could mean:\n• The QR code is expired or invalid\n• The assessment is not yet available\n• The assessment has been removed\n\nIf this issue persists, please contact your coordinator.",
            "ERROR-NETWORK": "Unable to connect to assessment server. This could mean:\n• Network connectivity issues\n• Server configuration problems (CORS)\n• The server might be temporarily unavailable\n\nPlease check your internet connection and try again. If the issue persists, contact support.",
            "ERROR-INVALID-QR": "Invalid QR code format. This could mean:\n• The QR code is not an IB assessment QR code\n• The QR code is damaged or unclear\n• The QR code format is not supported\n\nPlease ensure you are scanning a valid IB assessment QR code.",
            "ERROR-INVALID-HOST": "Invalid server address detected. This could mean:\n• The QR code points to an incorrect server\n• The QR code is from a different system\n\nPlease ensure you are using a QR code provided by IB.",
            "ERROR-GENERIC": "Failed to process QR code ({{error_type}}). This could mean:\n• There might be network connectivity issues\n• The server might be temporarily unavailable\n\nPlease try again. If the issue persists, contact support.",
            "ERROR-CAMERA-NOT-READABLE": "Camera access error. This could mean:\n• Another application is using the camera\n• The camera hardware has encountered an error\n\nPlease close other applications that might be using the camera and try again.",
            "ERROR-CAMERA-NOT-ALLOWED": "Camera permission denied. This could mean:\n• Camera access was blocked in browser settings\n• Camera permissions were not granted\n\nPlease check your browser settings and allow camera access.",
            "ERROR-PERMISSION-DENIED": "Permission denied. Please allow camera access in your browser settings.",
            "ERROR-NO-CAMERA": "No camera found. This app REQUIRES a webcam.",
            "ERROR-STORAGE-LOW": "Insufficient storage space. Only {{available_mb}} MB available, but {{required_mb}} MB required. Please free up space by removing unused assessments or files, then try again.",
            "ERROR-STORAGE-FULL": "Storage quota exceeded. The device does not have enough space to store this assessment. Please free up space by removing old assessments, then try again.",
            "SCAN-NEW-CODE": "Scan New Code",
            "CLOSE": "Close",

            "ACCESS-BLOCKED-HEADLINE": "Access Denied",
            "ACCESS-BLOCKED-NOT_CHROMEOS": "This application requires a ChromeOS device running in Kiosk Mode. Please contact your IT administrator.",
            "ACCESS-BLOCKED-NOT_KIOSK": "This device is not running in ChromeOS Kiosk Mode. Please contact your IT administrator to ensure the device is correctly provisioned.",
            "ACCESS-BLOCKED-NO_SCHOOL_CODE": "No school code has been provisioned on this device. Please contact your IT administrator.",
            "ACCESS-BLOCKED-INVALID_SCHOOL_CODE": "The school code provisioned on this device is not valid for assessments. Please contact your IT administrator.",
            "DEV-MODE-NOTICE": "Running outside of ChromeOS Kiosk Mode. This is permitted in development mode only."
        },
        "VM-DETECTION": {
            "EVENTLOG-INVIGILATOR-MESSAGE": "A virtual machine has been detected. The examination was unlocked by an invigilator.",
            "EVENTLOG-INVIGILATOR-UNLOCK-FAILED": "Incorrect invigilator code entered after a virtual machine was detected.",
            "EVENTLOG-INVIGILATOR-UNLOCK-SUCCESS": "Invigilator unlocked examination after a virtual machine was detected.",
            "EVENTLOG-INVIGILATOR-UNLOCK-WRONG-SUCCESS": "Unlock code may be candidate code but not an invigilator code.",
            "HEADLINE": "Virtual machine detected",
            "INFO": "This is not permitted.",
            "INPUT-HEADLINE": "Invigilator code",
            "INVIGILATOR-CODE": "Enter invigilator code",
            "MESSAGE": "You are attempting to run this examination in a \"Virtual Machine\" set up. <br /> Permission is required and an invigilator code must be entered to continue.",
            "MODAL-INVIGILATOR-TEXT-LABEL": "Enter a message or leave default",
            "MODAL-MESSAGE": "If you intend to allow the candidate to continue, despite using a Virtual Machine, please enter an invigilator code and then click <strong>Unlock</strong>. "
        },
        "LOGIN": {
            "HEADLINE": "Unlock your on-screen examination",
            "HEADLINE-MEDIA": "Unlock Music audio package",
            "HEADLINE_ENTER_KEY": "Enter your login details",
            "HEADLINE_ENTER_KEY_EXAMINER": "Enter your examiner key",
            "SCHOOL_CODE": "School code",
            "CANDIDATE_CODE": "Candidate code",
            "INVIGILATOR_CODE": "Invigilator code",
            "UNLOCK_CODE": "Access code",
            "UNLOCKFAILED": "<strong>Incorrect login details have been entered.</strong><br/>Please check and try again. Note: All fields are case sensitive.",
            "CONTENT": [
                "<em>Permission to reproduce content where third-party owned material protected by copyright is included has been sought and cleared where necessary, and where possible. Reasonable effort has been made to trace copyright holders, but if any items requiring clearance have unwittingly been included, we will be pleased to make amends at the earliest opportunity. Any trademarks™ or registered® trademarks included are used for illustrative purposes only, and use does not imply any affiliation with or endorsement by the International Baccalaureate.</em>",
                "<em>For assessment purposes, all acknowledgements of third-party material are stored and published separately.<br><br>The IB takes no responsibility and will not be liable for any technical issues (or otherwise) beyond its control or for any loss or damage suffered as a result of the use of or access to the platform from personal computers or computers other than school devices.</em>"
            ],
            "EVENTLOG_LOGIN_SUCCESS": "Candidate logged in successfully",
            "EVENTLOG_LOGIN_FAILED": "Candidate login attempt failed",
            "EVENTLOG_RELOGIN_HYBRID": "Candidate resumed examination after interruption. Response restored online.",
            "EVENTLOG_RELOGIN_DISK": "Candidate resumed examination after interruption."
        },
        "HELLOUSER": {
            "WELCOME": {
                "HEADLINE": "Welcome to the {{taskTitle}} examination",
                "USER_INFO": "We have identified you as:<br><br>Name: <strong>{{userInfo_completeName}}</strong><br><br>Candidate code: <strong>{{userInfo_candidateNo}}</strong><br><br>Date of birth: <strong>{{userInfo_birthDate}}</strong>.",
                "CONTENT": [
                    "Please confirm if this is correct."
                ]
            },
            "INCORRECT": {
                "HEADLINE": "Incorrect candidate details",
                "CONTENT": [
                    "You have confirmed that you are not <strong>{{userInfo_completeName}}</strong>, candidate code <strong>{{userInfo_candidateNo}}</strong>, date of birth <strong>{{userInfo_birthDate}}</strong>.",
                    "This means that you have entered the incorrect candidate code.",
                    "<strong>Please raise your hand and inform the invigilator immediately.</strong>"
                ]
            },
            "PERSONALDETAILS": {
                "HEADLINE": "Please enter your personal details",
                "INPUT": {
                    "FIRSTNAME": {
                        "LABEL": "First name",
                        "PLACEHOLDER": "Please enter your first name"
                    },
                    "LASTNAME": {
                        "LABEL": "Last name",
                        "PLACEHOLDER": "Please enter your last name"
                    },
                    "SCHOOLCODE": {
                        "LABEL": "School code",
                        "PLACEHOLDER": "Please enter your school code"
                    }
                },
                "FAILED": "Please complete all fields",
                "SCHOOLCODE_WARNING_TITLE": "Warning",
                "SCHOOLCODE_WARNING_BODY": "Using an incorrect school code may lead to your response not being identifiable or processable. Are you sure you want to change the school code?",
                "SCHOOLCODE_WARNING_CONFIRM": "Change school code",
                "SCHOOLCODE_WARNING_CANCEL": "Keep current",
                "SCHOOLCODE_EDIT_BTN": "Edit",
                "SCHOOLCODE_NUMERIC_ERROR": "School code must be numeric",
                "CONTENT": [
                    ""
                ],
                "BTN_SUBMIT": "Submit"
            },
            "RESUME": {
                "HEADLINE": "Please resume your examination",
                "CONTENT": "You have already completed part of the examination on this device.<br/>Please note that the time you have already taken to complete the examination will be deducted from your available time.<br><strong>If you believe this to be incorrect, please inform the invigilator.</strong>",
                "DIFFERENT_CANDIDATE_HEADLINE": "Existing response data found",
                "DIFFERENT_CANDIDATE_SUBTITLE": "belongs to a user that previously used this device",
                "DIFFERENT_CANDIDATE_CONTENT": "There is unfinished response data on this device.<br/>You may resume this session if it is yours, or start over to begin a new examination.",
                "PREVIOUS_CANDIDATE": "The session was started by: {{name}}",
                "PREVIOUS_CANDIDATE_EMAIL": "The session was started by: {{email}}",
                "CONTINUE_AS": "Continue as {{name}}",
                "START_OVER": "Delete and Start Over",
                "START_OVER_WARNING_TITLE": "Delete existing response data?",
                "START_OVER_WARNING_BODY": "The existing response data on this device will be permanently deleted and a new session will be started. This cannot be undone.",
                "START_OVER_CONFIRM": "Delete and Start Over",
                "BACKUP_FAILED": "Failed to back up the previous response data. Please try again or contact an invigilator."
            },
            "CAPTUREEMAIL": {
                "HEADLINE": "Email Address for response",
                "CONTENT": "This is a specimen assessment. Please provide the email address where you would like to receive your assessment results:",
                "INPUT": {
                    "EMAIL": {
                        "LABEL": "Email Address",
                        "PLACEHOLDER": "Please enter your email address"
                    }
                },
                "ERROR": "Please enter a valid email address."
            }
        },
        "INSTRUCTIONS": {
            "HEADLINE": "Instructions",
            "CONTENT": [
                "<strong>The on-screen examination has not yet started.</strong><br><br>",
                "Your time will begin once you have clicked the <strong>Start</strong> button below. Do not click <strong>Start</strong> until instructed to do so.<br><br>",
                "Before the examination begins you are given 5 minutes to become familiar with its structure. Please navigate around the examination, taking note of the length of each task and question. ",
                "You have <strong>{{taskTimeFormatted}}</strong> to complete the examination.<br><br>",
                "There are <strong>{{numSheets}}</strong> separate questions in this examination. Each question may have sub-parts.  ",
                "Answer all the questions in the response boxes provided. ",
                "The maximum {{markLabel}} for this examination is <strong>{{totalMarks}} {{marksLabel}}</strong>.<br><br>",
                "As you progress through the questions, your answers are automatically saved.<br><br>",
                "<strong>When {{ taskTimeFormatted }} has ended, you will no longer be able to answer any questions.</strong>"
            ],
            "IAA_PREFERENCES": "The following IA settings have been applied to your candidate record:",
            "EVENTLOG_START": "Candidate started the examination",
            "MINUTES": "minutes",
            "ASSESSMENT-EXPIRED":"Your total time has already elapsed. The examination cannot be started.",
            "SCREEN_RECORDING_STARTING": "Starting screen recording...",
            "SCREEN_RECORDING_ERROR_TITLE": "Screen Recording Required",
            "SCREEN_RECORDING_PERMISSION_DENIED": "Screen recording permission was denied. You must grant permission to continue.",
            "SCREEN_RECORDING_NOT_SUPPORTED": "Screen recording is not supported in this browser.",
            "SCREEN_RECORDING_ALREADY_ACTIVE": "Screen recording is already active.",
            "SCREEN_RECORDING_RESTART_FAILED": "Failed to restart screen recording. Please try again.",
            "SCREEN_RECORDING_UNKNOWN_ERROR": "An unknown error occurred while starting screen recording",
            "SCREEN_RECORDING_PERMISSION_HELP": "To grant screen recording permission:",
            "SCREEN_RECORDING_PERMISSION_STEP1": "Click the 'Try Again' button below",
            "SCREEN_RECORDING_PERMISSION_STEP2": "When prompted, select 'Entire Screen' or your specific screen",
            "SCREEN_RECORDING_PERMISSION_STEP3": "Click 'Share' to grant permission",
            "SCREEN_RECORDING_NOT_SUPPORTED_HELP": "Please use a supported browser (Chrome, Firefox, Edge) that supports screen recording.",
            "SCREEN_RECORDING_RETRY": "Try Again",
            "SCREEN_RECORDING_MANDATORY": "Screen recording is mandatory for this examination.",
            "SCREEN_RECORDING_CONTACT_ADMIN": "Please contact your examination administrator for assistance."
        },
        "TASKDONE": {
            "HEADLINE": "The examination has now ended",
            "INSTRUCTIONS": "<strong>Do not attempt to logout, shutdown or remove your device.</strong><br/><br/>Follow any additional instructions from the invigilator.",
            "PACK-RESPONSE": "Collecting data and packing response",
            "UPLOADING-RESPONSE": "Uploading response",
            "ATTEMPT": "Attempt",
            "UPLOAD-SUCCESS": "The response file has been successfully uploaded. You may now <strong>Exit</strong> the examination package.",
            "UPLOAD-PENDING": "The response has not yet been submitted to the IB.",
            "UPLOAD-FAILED": "A problem occurred while uploading the response file. Please <strong>Retry upload</strong> once.",
            "RETRYING-UPLOAD": "Upload failed. Automatically retrying...",
            "PACK-FAILED": "Packing response data failed. Your response data has been saved and can be recovered. Please contact your invigilator.",
            "RETRY-UPLOAD": "Retry upload",
            "TRY-UPLOAD": "Attempt to upload response",
            "EXIT": "Exit",
            "SAVE-TO-FS": "The response file has failed to upload automatically. You can <strong>Attempt to upload response</strong> again, or <strong>Exit</strong> and submit the response file manually. The response file can be retrieved from the Documents folder on this device.",
            "SAVE-TO-FS-BUTTON": "Copy response file to a different folder",
            "DP-MEDIA":{
                "HEADLINE": "The examination has now ended",
                "INFO":"The examination has now ended.<br><br>Please listen to the invigilator for additional instructions.<br><br>This application will automatically close after 30 seconds."
            }
        },
        "NAVBAR": {
            "SELECT-KEYBOARD-LANG": "Keyboard-Language",
            "HIGHLIGHT-TOOL": "Highlight tool",
            "CALCULATOR": "Calculator",
            "DIRECTIVE": {
                "BOOKMARKED": "Bookmarked<br />Questions"
            },
            "DIRECTIVEINSTRUCTIONSLONG": "<h4>General</h4>    <p>        Answer all questions in the time allocated.  If you have any problems during the examination, raise your hand and inform the invigilator.    </p>    <h4>Navigation</h4>    <p>        <b>Question Previews</b><br>        The home screen displays a preview of all the questions in the examination. Clicking anywhere on a question preview will open the full question.<br><br>        The full question will contain more information than the preview. Ensure you read all the material before answering.     </p>    <p>        <b>Right Hand Menu</b><br>        The right hand side of the screen contains a menu which displays a list of all the questions in the examination.<br><br>        Clicking on a question number will expand the question to show how many sub-parts the question has. Then, clicking on any of the sub-parts will display the question in the main window.    </p>        <h4>Statuses</h4>    <p>        There are 3 states that a question can be in:    </p><ul><li>Not started</li><li>In progress</li><li>Complete</li></ul>    When you begin the examination, all questions will be in the \"Not started\" state. As soon as you begin to answer a question the system will automatically change the status of that question to \"In progress\".  Once you navigate away from a question the status will be changed to \"Complete\" (you can always go back and amend your answer after this if you need to).<br><br>   <p><br></p>",
            "DIRECTIVEINSTRUCTIONSLONG-MEDIA": "<h4>General</h4><p>If you have a problem, please inform your invigilator.</p><p><br></p>",
            "DIRECTIVEINSTRUCTIONS": {
                "GENERAL": {
                    "HEADLINE": "Généralité",
                    "CONTENT": ""
                },
                "NAVIGATION": {
                    "HEADLINE": "Navigation",
                    "CONTENT": [
                        "<b>Aperçu des questions</b><br>L’espace principal de l’écran d’accueil présente un aperçu de toutes les questions de l’évaluation. En cliquant sur l’aperçu d’une question, vous ouvrirez la question complète.<br><br>La question complète comprendra plus d’information que son aperçu. Veillez donc à bien lire tout le contenu avant de répondre à une question.",
                        "<b>Menu à droite de l’écran</b><br>Vous trouverez à droite de l’écran un menu contenant une liste de toutes les questions de l’évaluation.<br><br>Cliquer sur le numéro d’une question en révèlera les parties. Cliquer sur une partie vous amènera au début de la question."
                    ]
                },
                "STATUSES": {
                    "HEADLINE": "Statuts",
                    "CONTENT": [
                        "Chaque question peut avoir l’un des trois statuts suivants:<ul><li>Non commencée</li><li>Commencée</li><li>Terminée</li></ul>Lorsque vous commencerez l’évaluation, toutes les questions auront &quot;Non commencée&quot; comme statut. Dès que vous commencerez à répondre à une question, son statut passera à &quot;Commencée&quot;. Une fois que vous êtes satisfait(e) de votre réponse, vous pouvez en changer le statut et la marquer comme &quot;Terminée&quot; (vous pouvez toutefois à tout moment y revenir et modifier votre réponse si vous le souhaitez).<br><br>La barre de progression vous donne un aperçu de votre progression dans l’évaluation en vous indiquant le statut des différentes questions."
                    ]
                }
            },
            "DIRECTIVEQUIT": {
                "HEADLINE": "Please confirm",
                "CONTENT": "Are you sure you want to quit? This will end the examination."
            },
            "FINISH-EARLY": {
                "HEADLINE": "Warning! Finish early",
                "LABEL": {
                    "LASTNAME": "Last name",
                    "FIRSTNAME": "First name"
                },
                "TOOLTIP": {
                    "DISABLED-FINISH-EARLY-BTN": "Only becomes available after 60 minutes"
                },
                "WARNING-CONTENT": [
                    "You have selected to end this examination early.",
                    "If you proceed, the examination will end and you will not be able to return.",
                    "Do you still wish to end this examination early?"
                ],
                "CONFIRM-CONTENT": [
                    "You have confirmed that you wish to finish this examination early.",
                    "To proceed, please enter you name below and click <strong>Finish Early</strong>. Alternatively, you may still <strong>Cancel</strong> this process and return to the examination."
                ],
                "JOURNAL-EXITS": "Do you want to complete the Journal?"
            }
        },
        "SIDEBAR": {
            "HEADLINE": "Status Map",
            "TOOLTIP": {
                "COMPLETE": "Flagged as complete",
                "COMPLETED": "Complete",
                "NOTSTARTED": "Not Started",
                "PARTLY-COMPLETED": "In Progress"
            },
            "BUTTONS": {
                "SCROLL-UP": "Previous Question",
                "SCROLL-DOWN": "Next Question"
            }
        },
        "QUESTION": {
            "HINTOPTION": "Hint option",
            "BACKTOOVERVIEW": "Back to question overview"
        },
        "JOURNAL": {
            "HEADLINE": "Journal",
            "CONTENET": [
                "The examination is now over, an <strong>optional</strong> 10 minute questionnaire follows called the Reflection Journal. Please use the Reflection Journal to reflect on your experience of preparing for and taking the examination. Do you wish to complete the Journal?"
            ],
            "CONFIRM-SAVE": "Are you sure you want to complete your Journal?"
        },
        "SHEET": {
            "READING-TIME": {
                "MODAL": {
                    "HEADLINE": "Reading Time",
                    "CONTENT": [
                        "The reading time has now ended. Please press <strong>Start</strong> to begin the examination."
                    ]
                },
                "OVERLAY": {
                    "LABEL": "Reading Time"
                }
            }
        },
        "CHANGELANGUAGE": {
            "LABEL": "Select System - Language",
            "LANGUAGES": {
                "EN": "English",
                "ES": "Español",
                "FR": "Français"
            }
        },
        "WIRIS-CKEDITOR-PLUGIN": {
          "BTN-CANCEL": "Cancel",
          "BTN-OK": "Confirm - Insert equation",
          "OVERLAY-MSG": "Please enter your equation below and press <i>Confirm - Insert equation</i>",
          "SHEET-LEAVE-MSG": "In {{s}}, you have started entering an equation but have not confirmed it. Are you sure you want to discard the equation? It will not be included in your response.",
          "SHEET-LEAVE-TITLE": "Equation Editor"
        },

        "SHEET-LEAVE":{
            "MODAL":{
                "HEADLINE":"Warning",
                "BTN":{
                    "CANCEL": "Return to question",
                    "CONFIRM": "Leave question"
                }
            }
        },
        "CALCULATOR": {
            "MODAL": {
                "HEADER": "Calculator",
                "BUTTONS": {
                    "CLOSE":{
                        "TOOLTIP":"Close Calculator"
                    },
                    "DRAG":{
                        "TOOLTIP":"Drag Calculator"
                    }
                }
            }
        }

    },
    "BTN": {
        "PAUSE": "Pause",
        "CANDIDATE-PAUSE": "Pause",
        "BACK": "Back",
        "UNLOCK": "Unlock",
        "RESET-TIME": "Reset time",
        "CORRECT": "Correct",
        "QUIT": "Quit",
        "FINISH-EARLY": "Finish early",
        "QUIT-APP": "Quit examination",
        "SUBMIT": "Submit",
        "CONTINUE": "Continue",
        "START": "Start",
        "ADMIN_MENU": "Invigilator Menu",
        "INVIGILATOR": "Invigilator",
        "ASSISTANCE": "Assistance",
        "INSTRUCTIONS": "Instructions",
        "BOOKMARKS": "Bookmarks",
        "OK": "OK",
        "CANCEL": "Cancel",
        "BACKGROUNDRESOURCE": "Background Resources",
        "CLOSE": "Close",
        "PRE-RELEASE": "Pre-release",
        "EXTRA-TIME": "Additional time",
        "RECORD-INCIDENT": "Record incident",
        "CONFIRM-PAUSE": "Confirm",
        "CONFIRM-EXTRA-TIME": "Confirm",
        "CONFIRM-INCIDENT": "Confirm logging of incident",
        "UNLOCK-ASSESSMENT": "Resume examination",
        "RESUME-ASSESSMENT": "Resume examination",
        "INVIGILATOR-ACCESS": "Invigilator access",
        "RESUME": "Resume",
        "RETRY-UPLOAD": "Retry upload",
        "YES": "Yes",
        "NO": "No",
        "SAVE": "Save",
        "QUIT-EARLY-ASSESSMENT": "End examination",
        "QUIT-ASSESSMENT": "Leave package",
        "CARRY-ON": "Continue",
        "END-ASSESSMENT": "End examination",
        "RESTART": "Confirm restart",
        "GOTO-JOURNAL": "Yes",
        "CONFIRM": "Confirm"
    },
    "CONTENT": {
        "COPYRIGHT_TEXT": "© International Baccalaureate Organization {{year}}. All rights reserved.",
        "SCROLLINFO": "Scroll down to continue",
        "PROCESSING": "Processing",
        "MARK": "mark{{totalMarks > 1 && 's' || ''}}"
    },
    "BACKGROUND": {
        "TAB": {
            "READING": "Reading",
            "VIDEO": "Video"
        }
    },
    "SYSTEM": {
        "CLOCK": {
            "REMAINING": "Remaining",
            "ELAPSED": "Elapsed",
            "NONE": "Hide clock",
            "HOURS": "hours",
            "HOUR": "hour",
            "MINUTES": "minutes",
            "MINUTE": "minute",
            "SECONDS": "seconds",
            "SECOND": "second",
            "PAUSED": " (pause)"
        },
        "SAVEINDICATOR": {
            "SAVING": "Saving...",
            "SAVED": "Responses saved"
        },
        "FOCUSLOST": {
            "TITLE": "Focus lost",
            "WARNING": "The system has detected that focus was lost from the examination / an attempt was made to exit the examination.",
            "LOGGED": "This has been recorded in your response file.",
            "ALTERNATIVE": {
                "TITLE": "Focus lost",
                "WARNING": "A loss of focus has occurred. However, no further action is required and you may continue with your assessment."
            }
        }
    },
    "TOOLTIPS": {
        "BOOKMARKBTN": "Show bookmarked questions",
        "ISBOOKMARKED": "Unbookmark this question",
        "ISNOTBOOKMARKED": "Bookmark this question",
        "FLAGASCOMPLETE": "Flag as complete",
        "FLAGASUNCOMPLETE": "Flag as incomplete"
    },
    "VIDEOPLAYER": {
        "FULLSCREEN": "Fullscreen toggle",
        "SUBTITLE_ON": "Enable subtitles",
        "POSTROLLCLOSE": "Close",
        "PLAYPAUSE": "Play/Pause",
        "MUTE": "Mute toggle",
        "STOP": "Stop",
        "CAPTION": "Subtitles",
        "CAPTION_NONE": "Disable"
    },
    "IAA": {
        "iaa": "IAA",
        "allegedAcademicMisconduct": "Alleged academic misconduct",
        "disruptionToExam": "Disruption to examination",
        "pause": "Examination paused by invigilator",
        "resumeByInv": "Examination resumed by invigilator",
        "resumeByCand": "Examination resumed by candidate",
        "extratime": "Additional time assigned by invigilator",
        "genericNote": "Generic note / other incident",
        "loginSuccess": "Successful login",
        "loginFailed": "Login failed",
        "invLoginSuccess": "Successful login",
        "invLoginFailed": "Login failed",
        "assessmentStart": "Examination started",
        "resume": "Examination resumed",
        "fireAlarm": "Fire alarm",
        "anyOther": "Other",
        "toiletBreak": "Candidate required a toilet break",
        "candidateCanPause": "Candidate can pause",
        "dyslexicFont": "Alternative accessible font",
        "zoomLevel": "Zoom level",
        "extraTime": "Additional time",
        "colorTheme": "Colour theme",
        "extraTimeInfo": "Total time: {{ totalTimeAvailable }}, {{ timeElapsed }} elapsed, {{ timeLeft }} remaining",
        "videoSubtitleAutoEnable": "Video subtitle auto-enable",
        "activated": "Activated '{{key}}'",
        "deactivated": "Deactivated '{{key}}'",
        "changedValue": "Changed '{{key}}' setting from '{{oldVal}}' to '{{newVal}}'.",
        "changedValueNoPreviousValue": "Changed '{{key}}' setting to '{{newVal}}'.",
        "examinationAdministrationIssue": "Examination administration issue",
        "candidateIllness": "Candidate illness",
        "candidateIllnessTemporaryMedicalCondition": "Candidate illness / temporary medical condition",
        "extremeWeatherCondition": "Extreme weather conditions",
        "inclusiveAssessmentArrangements": "Inclusive assessment arrangements",
        "misconductDuringExamination": "Misconduct during examination",
        "unauthorizedMaterialInExamination": "Taking unauthorised material into examination",
        "unethicalPractice": "Unethical practice",
        "multipleResponseFiles": "Multiple response files",
        "finishEarlyByCandidate": "Finish early by candidate",
        "duplicateResponseFile": "Duplicate response file uploaded",
        "finishEarlyByInvigilator": "Finish early by invigilator",
        "focusLost": "Application focus lost",
        "focusLostAlternative": "Application focus lost",
        "leavePackageEarlyByInvigilator": "Leave package early by Invigilator",
        "alternativeContent":  "Alternative content",
        "alternativeContents": {
            "visuallyImpaired": "visually impaired"
        },
        "assessmentReStartHybrid": "Re-log in online",
        "assessmentReStartDisk": "Re-log in",
        "responseFileBlank": "Blank response file"
    },
    "CONTENTOBJECT": {
        "RESPONSE-SHORT-TEXT": {
            "LABEL": ""
        },
        "TABEL": {
            "NEXT-STEP": "Next Step",
            "RESET": "Reset",
            "ALIGNMENT": "Alignment",
            "STEP1": "Step 1",
            "STEP2": "Step 2",
            "STEP3": "Step 3",
            "ROWS": "Rows",
            "COLS": "Cols",
            "LOCKED": "Locked",
            "TABLE-SIZE": "Table Size",
            "TABLE-DATA": "Table Data",
            "HELPTEXT-1": "Please choose the alignment of your table: <strong>Horizontal</strong> (row headings on the left) or <strong>Vertical</strong> (column headings on the top)",
            "HELPTEXT-2": "Please choose the number of rows and columns in your table (you may add/delete row/columns later).",
            "HELPTEXT-3": "Please enter your data into the table (including any headings)",
            "CTX-MENU": {
                "READ-ONLY": "Read only",
                "REMOVE-ROW": "Remove Row",
                "REMOVE-COL": "Remove Col",
                "ROW-ABOVE": "Row Above",
                "ROW-BELOW": "Row Below",
                "COL-LEFT": "Col Left",
                "COL-RIGHT": "Col Right",
                "MERGE-CELLS": "Merge cells",
                "UNMERGE-CELLS": "Unmerge cells",
                "FORMAT-AS-HEADER-ROW": "Format as Header Row",
                "FORMAT-AS-HEADER-COLUMN": "Format as Header Column",
                "SET-AS-HEADER-CELL": "Set as Header Cell",
                "UNSET-AS-HEADER-CELL": "Unset Header Cell",
            },
            "CREATE-NEW-TABLE-OBJECT": "Create New Table",
            "CREATE-TABLE-SIZE": "Create Table with {{cols}} columns and {{rows}} rows"
        },
        "IAA-CONTAINER": {
            "ADD-NEW-BTN": "Add IAA-Container",
            "FILTER-BTN": "Show: ",
            "FILTER-BTN-PREVIEW": "IAA-Content: ",
            "IAA-CONTAINER": {
                "all": "All",
                "default": "Default",
                "visuallyImpaired": "Visually Impaired"
            },
            "WARNING-MESSAGES":{
                "IS-DEFAULT":"Falling back to the default section for this IAA Container",
                "IAA-CONTAINER-NOT-EXISTS": "'{{s}}' section does not exist!",
                "IAA-OBJECTS-NOT-EXISTS": "No object defined in '{{s}}' section!"
            }
        },
        "CAROUSEL": {
            "LOADING": "Carousel loading...",
            "LOADING_COPY_CONTAINER_DOWNLOAD_MEDIA": "Media is being downloaded...",
            "LOADING_COPY_CONTAINER_CHECKING_MEDIA": "Content is being verified..."
        },
        "RESPONSETEXTBOX": {
            "HIGHLIGHT": "Highlight",
            "QUESTION-HIGHLIGHT": "Question highlight",
            "IMAGE-FROM-CALC": "Image from calculator",
            "LAODING":"loading ...",
            "LOADING-FAILED":"Richtext can not be loaded. Please call the invigilator.",
            "ERRORS":{
                "UNLOADED":{
                    "HEADLINE":"An error has occurred",
                    "MESSAGE":"Richtext can not be loaded.<br>Please call the invigilator.<br><strong>{{errorMessage}}</strong>"
                }
            }
        },
        "TAB": {
            "LOADING": "Tabs loading..."
        },
        "IFRAME": {
            "CONTENT": [
                "<p><strong>IFrame content placeholder</strong><br/>Iframe content has been selected and will be shown in preview mode only.<br/>This box presents the dimensions selected however.</p>",
                "<p><strong>IFrame content placeholder</strong><br/>No IFrame content has been selected yet.<br/>Please use the \"Browse media\" button to select (already uploaded) IFrame content.</p>"
            ],
            "HAS-PREVIEW-URL": "<p><strong>This IFrame has a Preview URL set! Please note that the content displayed in preview mode and a package will differ!"
        },
        "HINT": {
            "TITLE": "Hint",
            "EXPLANATION": "This hint will display helpful information if accepted<br/><strong>If you take this hint {{marks}} Marks will not be achievable anymore.</strong>",
            "EXPLANATION2": "Are you sure you want to accept this hint?<br/><strong>You will not be able to achieve {{marks}} for this question.</strong>",
            "CONFIRM1": "I understand",
            "CANCEL1": "Cancel",
            "CONFIRM2": "Take hint",
            "CANCEL2": "Cancel",
            "TAKEN": "HINT TAKEN - Associated marks no longer achievable: {{marks}}",
            "TAKEN-PDF": "HINT LEVEL {{level}} TAKEN - Please deduct {{marks}} mark(s) for this level",
            "TOTAL-TAKEN-PDF": "HINT LEVEL {{levels}} TAKEN - Please deduct {{marks}} mark(s)"
        },
        "SCATTERGRAPH": {
            "GRAPH-SETTINGS": "Graph Settings",
            "OPEN-GRAPH-SETTINGS": "Open Graph Settings",
            "GRAPH-TITLE": "Graph Title",
            "X-LABEL": "X Axis Label",
            "Y-LABEL": "Y Axis Label",
            "X-DECIMALS": "Number of decimal places displayed (X Axis)",
            "Y-DECIMALS": "Number of decimal places displayed (Y Axis)",
            "X-MINIMUM": "X Axis - Minimum Value ",
            "Y-MINIMUM": "Y Axis - Minimum Value ",
            "X-INCREMENT": "X Axis - Increment/Scale",
            "Y-INCREMENT": "Y Axis - Increment/Scale",
            "CLOSE": "Close",
            "SAVE-CHANGES": "Apply Changes",
            "LINE-TOOL": "Draw Line",
            "RECTANGLE-TOOL": "Plot Blue Point",
            "CIRCLE-TOOL": "Plot White Point",
            "DIAMOND-TOOL": "Plot Red Point",
            "TRIANGLE-TOOL": "Plot Green Point",
            "POLYGON-TOOL": "Plot Yellow Point",
            "LABEL-OUTLIER": "Identify an outlier",
            "LABEL-REGION": "Identify a region",
            "INSTRUCTIONS-LABEL": "Instructions",
            "INSTRUCTIONS-TEXT": "click \"START\" to begin plotting your graph",
            "INSTRUCTIONS-BUTTON": "START",
            "X-DEFAULT-LABEL": "x Label",
            "Y-DEFAULT-LABEL": "y Label",
            "DEFAULT-TITLE": "Title",
            "REGION": "region",
            "OUTLIER": "outlier"
        }
    },
    "PREFIX": {
        "QUESTION": "Question",
        "QUESTION-PART": "Question",
        "PRE-RELEASE": "Pre-release",
        "JOURNAL": "Journal"
    },
    "AUTOPLOT": {
        "OPENWIZARD": "Open chart wizard",
        "SCATTER": "Scatter",
        "BAR": "Bar chart",
        "PIE": "Pie chart",
        "SELECTIONMODE-INFOTEXT": {
            "FULL": "Click on Column or Row header to Select {{axis}} in {{series}}.",
            "FIELDS": "Click and hold to select Data for {{axis}}.",
            "FIELDS_SERIES": "Click and hold to select Data for {{axis}} in {{series}}."
        },
        "CHARTSETTINGS": {
            "TITLE": "Chart title",
            "TITLE-PLACEHOLDER": "Enter chart title here",
            "LABELS": "Labels",
            "SELECT-LABELS": "Select labels",
            "LABELS-PLACEHOLDER": "Please select labels",
            "VALUES": "Values",
            "VALUES-PLACEHOLDER": "Please select values",
            "X-LABEL": "Label for X",
            "X-LABEL-PLACEHOLDER": "Enter label for X here",
            "X-VALUES": "Values for X",
            "X-VALUES-PLACEHOLDER": "Please select values",
            "Y-LABEL": "Label for Y",
            "Y-LABEL-PLACEHOLDER": "Enter label for Y here",
            "Y-VALUES": "Values for Y",
            "Y-VALUES-PLACEHOLDER": "Please select values",
            "RESET-VALUES": "Reset values",
            "SELECT-VALUES": "Select values",
            "SERIES-NAME": "Series name",
            "SERIES-NAME-PLACEHOLDER": "Enter series name here",
            "NEW-SERIES-BTN": "Add series",
            "REMOVE-SERIES-HOVER": "Remove series completely"
        },
        "LOBF": {
            "HIDE": "Hide Line of Best Fit",
            "SHOW": "Show Line of Best Fit",
            "DRAW": "Draw Line of Best Fit"
        }
    },
    "REPORTS": {
        "DIALOGS": {
            "TYPE": {
                "WARNING": "Warning",
                "INFO": "Information",
                "CONFIRM": "Please confirm"
            },
            "ERRORS": {
                "NO-EXPORT-DATA": "There is no data to be exported"
            }
        },
        "TABS": {
            "ANOMALIES": "By Anomaly",
            "CORRUPTED-FILES": "By Corrupted Files"
        },
        "TOOLTIPS": {
            "BUTTONS": {
                "EXPORT-BTN": "Export as Excel Sheet",
                "REFRESH-BTN": "Refresh view"
            }
        },
        "ANOMALIES": {
            "LIST": {
                "TITLE": "Response File Anomaly Report",
                "SEARCH": "Search:",
                "FILTER": "Filters:",
                "SESSION": "Session:",
                "LEGEND": {
                    "ALREADY-SUBMITTED": "Additional file received after submission",
                    "RESPONSEFILE-IN-ABSENCE": "File received after flagged absent",
                    "BEFORE-TIMEFRAME": "Early submission",
                    "AFTER-TIMEFRAME": "Late submission",
                    "FOCUS-LOST": "Focus Lost",
                    "CAPTURED-BUT-CANNOT-IDENTIFY-CASE": "Unclassified case"
                },
                "GRID": {
                    "REASON": "Flag",
                    "PAPER-CODE": "Paper Code",
                    "PAPER-NAME": "Paper Name",
                    "CANDIDATE-NAME": "Candidate",
                    "CANDIDATE-LASTNAME": "Candidate last name",
                    "CANDIDATE-FIRSTNAME": "Candidate first name",
                    "CANDIDATE-NUMBER": "Candidate Number",
                    "SCHOOL-CODE": "School Code",
                    "RESPONSE-FILE": "Response Filename",
                    "ACTIONS": {
                        "OPEN-REPORT": "Open"
                    }
                },
                "TOOLTIP": {
                    "SCHOOL-NAME": "School:",
                    "ASSESSMENT-TIMEFRAME": "Assessment's time frame:",
                    "RESPONSE-TIME": "Additional submission:",
                    "SUBJECT": "Subject:",
                    "SUBMITTED-ON": "First Submission:"
                },
                "REMOVE-FILTERS-BTN": "Remove all filters"
            }
        },
        "CORRUPTED-FILES": {
            "LIST": {
                "TITLE": "Corrupted Response Files Report",
                "SEARCH": "Search:",
                "LEGEND": {
                    "VIRUS": "Virus",
                    "CORRUPTED-ZIP": "Corrupted Zip file",
                    "ZEROBYTE": "File with Zerobytes",
                    "UNIDENTIFIED-CASE": "Unidentified case"
                },
                "GRID": {
                    "RESPONSE-FILE": "Filename",
                    "DATE-TIME": "Date/Time Received",
                    "RESULT": "Result"
                },
                "RESULTS": {
                    "VIRUS": "Virus",
                    "CORRUPT-ZIP": "Corrupted Zip File",
                    "ZEROBYTE": "Zero bytes"
                },
                "REMOVE-FILTERS-BTN": "Remove all filters"
            }
        }
    },
    "ADMIN-UI": {
        "ASSESSMENT": {
            "TOOLTIPS":{
                "REMOVE-FILTERS-BTN": "Remove all filters",
                "REMOVE-FILTER-BTN": "Remove filter",
                "EXPORT-BTN": "Export",
                "REFRESH-BTN": "Refresh"
            },
            "LIST": {
                "SHOW-STATISTICS": "Show statistics",
                "TITLE": "Admin Console - examination list",
                "TITLE-ASSESSMENT": "Examination list",
                "TITLE-SCHOOL": "School list",
                "GRID": {
                    "TITLE": "Title",
                    "SUBJECT": "Subject",
                    "PAPER-CODE": "Paper code",
                    "SESSION": "Session",
                    "LANGUAGE": "Language",
                    "SCHOOL-NAME": "School name",
                    "SCHOOL-CODE": "School code",
                    "PROGRAMME": "Programme",
                    "CANDIDATES-REGISTERED": "Candidates (registered)",
                    "RESPONSES-RECEIVED": "Candidates /w response file",
                    "RESPONSES-OUTSTANDING": "Response files outstanding",
                    "SUBMISSIONS": "Submissions",
                    "SUBMISSIONS-OUTSTANDING": "Submissions outstanding",
                    "SUBMISSIONS-ABSENT": "Total submitted Absent",
                    "TOTAL-SCHOOLS": "Total schools",
                    "TOTAL-FILES-UNMATCHED": "Total response files unmatched",
                    "TOTAL-INCIDENTS": "Total incidents",
                    "ACTIONS": {
                        "OPEN-SCHOOL-LIST": "Open schools",
                        "OPEN-ASSESSMENT-LIST": "Open Assessment List",
                        "OPEN-ASSESSMENT-DETAIL": "Open detail"
                    }
                },
                "SELECT-DEFAULT": {
                    "SUBJECT": "Select subject",
                    "LANGUAGE": "Select language",
                    "SESSION": "Select session"
                },
                "FILTER": "Filter",
                "FILTERS": {
                    "NO-RESPONSE-FILE": "No response files uploaded",
                    "ALL-RESPONSE-FILE": "All response files uploaded",
                    "MISSING-RESPONSE-FILE": "Missing response files",
                    "NO-DOWNLOADS": "No downloads yet",
                    "NO-SUBMISSIONS": "No submissions yet",
                    "ALL-SUBMISSIONS": "All submissions complete",
                    "MISSING-SUBMISSIONS": "Missing submissions"
                },
                "SEARCH": "Search",
                "PLACEHOLDER": {
                    "SCHOOL-NAME": "School name",
                    "SCHOOL-CODE": "School code"
                },
                "SELECTED-FILTER":"Selected Filters",
                "FILTER-TEXT": {
                    "statistics":          "Statistics",
                    "search":              "Search <strong>\"{{s}}\"</strong>",
                    "subject":             "Subject <strong>\"{{s}}\"</strong>",
                    "language":            "Language <strong>\"{{s}}\"</strong>",
                    "session":             "Session <strong>\"{{s}}\"</strong>",
                    "school_code":         "School-Code <strong>\"{{s}}\"</strong>",
                    "school_name":         "School-Name <strong>\"{{s}}\"</strong>",
                    "no_downloads":        "No downloads yet",
                    "no_responses":        "No response files uploaded",
                    "all_responses":       "All response files uploaded",
                    "missing_responses":   "Missing response files",
                    "no_submissions":      "No submissions yet",
                    "all_submissions":     "All submissions complete",
                    "missing_submissions": "Missing submissions"
                }
            },
            "DETAIL": {
                "TITLE": "Examination",
                "SEARCH": "Search for candidates",
                "SUBMISSIONS-COMPLETE": "All submissions complete for this examination",
                "PIRATE-FILES-INFO": "We have detected that <span class=\"label label-danger\"><strong>{{ pirate_response_files_count }}</strong> response files</span> have been received that cannot be automatically matched against registered candidates.<br><br>Please match these to candidates manually.",
                "UPLOAD-DONE": "Upload complete.",
                "UPLOAD-CONFIRM-MESSAGE-DONE": "All response files were successfully uploaded.<br><br>Please allow 1-3 hours for the response file(s) to process.",
                "UPLOAD-CONFIRM-MESSAGE-ERROR": "Problems occurred. Some files were not uploaded: <br>",
                "FILTERS": {
                    "MISSING-RESPONSE": "Missing response file",
                    "INCIDENTS-LOGGED": "Incidents logged",
                    "IGNORE-SUBMITTED": "Hide submitted candidates"
                },
                "CANDIDATE-LIST": {
                    "TITLE": "Candidates",
                    "INFO-PANELS": {
                        "NO-RESPONSE": "No response file received",
                        "RESPONSE-RECEIVED": "Response file received on {{ received_on }}",
                        "ONE-OPEN-INCIDENT": "There is 1 open incident",
                        "MULTIPLE-OPEN-INCIDENTS": "There are {{ count }} open incidents",
                        "SUBMITTED_ON": "Submitted to IB",
                        "RESPONSE-FILES-RECEIVED": "{{count}} response file received and currently being processed",
                        "RESPONSE-FILES-SUCCESS": "{{count}} response file processed successfully and now ready for submission",
                        "DUPLICATE-RESPONSE-FILES": "{{count}} duplicate response files received",
                        "FILE-NAME": "File Name",
                        "RESPONSE-BLANK": "This response file does not contain any candidate response data"
                    },
                    "TOOLTIP":{
                        "DUPLICATE-RECEIVED-FILE":"Duplicate response file received"
                    },
                    "CAPTURED-INCIDENTS": {
                        "TITLE": "Captured and recorded incidents",
                        "INCIDENT": "Incident",
                        "TIME": "Time",
                        "NOTE": "Note",
                        "ADD-NOTE": "Add note"
                    },
                    "CAPTURE-NEW-INCIDENT": "Capture new incident",
                    "SUBMIT-TO-IB": "Submit to IB",
                    "SUBMITTED-TO-IB": "Submitted to IB",
                    "UNSUBMIT-CANDIDATE": "Unsubmit candidate",
                    "ATTENDANCE_PREFIX": "Attendance",
                    "CHECK-HYBRID-RESPONSE-BTN": "Attempt online response recovery"
                },
                "ACTIONS": {
                    "SELECT-ALL": "Select all",
                    "SUBMIT-SELECTED": "Submit selected",
                    "ADD-GLOBAL-NOTE": "Apply global note",
                    "ADD-NEW-GLOBAL-INCIDENT": "Create global incident"
                },
                "STATISTICS": {
                    "CANDIDATES-REGISTERED": "Candidates registered: {{ count }}",
                    "CANDIDATES-WITH-RESPONSES": "Candidates with response file: {{ count }}",
                    "CANDIDATES-ABSENT": "Candidates declared absent: {{ count }}",
                    "DROP-FILES": "Drop response files here",
                    "UPLOAD-FILES": "Upload {{ count }} files",
                    "UNMACHTED-RESPONSES": "Manually match response files",
                    "FILE-REJECTED": "1 file has been rejected.",
                    "FILES-REJECTED": "{{ count }} files have been rejected."
                },
                "CHART": {
                    "NOT-SUBMITTED": "Not yet submitted",
                    "SUBMITTED": "Submitted",
                    "SUBMITTED-TITLE": "Response files submitted",
                    "CANDIDATES-ABSENT": "Absent candidates",
                    "RESPONSE-RECEIVED-TITLE": "Candidates with response file",
                    "RESPONSE-RECEIVED": "Received",
                    "RESPONSE-MISSING": "Outstanding"
                },
                "ORDERBY": {
                    "PREFIX": "Order by",
                    "FIRST-NAME": "First name",
                    "LAST-NAME": "Last name",
                    "CANDIDATE-CODE": "Candidate code"
                },
                "DIALOG": {
                    "INCIDENT": {
                        "HEADER": "Incident details",
                        "TITLE": "Captured incidents <span class=\"small\">for</span>",
                        "TITLE-GLOBAL-INCIDENT": "Global note",
                        "TITLE-NEW-GLOBAL-INCIDENT": "Global incident",
                        "PANEL-TITLE": "Candidates",
                        "INCIDENT-EXPLAINS-OTHER": "This incident explains other incidents logged for the candidate",
                        "CANDIDATE-NAME": "Candidate name",
                        "CANDIDATE-DATE-OF-BITH": "Date of birth",
                        "CANDIDATE-CODE": "Candidate code",
                        "CAPTURED-INCIDENT": "Apply incident note",
                        "INCIDENT-TYPE": "Incident type",
                        "INCIDENT-TYPE-PLACEHOLDER": "-- Select incident type --",
                        "INCIDENT-REASON-PLACEHOLDER": "-- Select reason --",
                        "DESCRIPTION": "Description",
                        "EXPLANATORY-NOTE-CAPTURED": "Explanatory note captured?",
                        "EXPLANATORY-NOTE-PLACEHOLDER": "Please enter an explanatory note",
                        "EXPLAINED-BY": "Explained by the incident above",
                        "ATTACH-GLOBAL-NOTE": "Apply global note",
                        "INCIDENTS-NOT-EXISTS": "There are no open incidents which require an explanatory note to be added. You cannot add a global note.",
                        "CANCEL": "Cancel",
                        "SAVE": "Save",
                        "SELECT-ALL":"Select all",
                        "DESELECT-ALL":"Deselect all",
                        "ERROR-DIALOG-HEADLINE":"Sorry, an error occurred!",
                        "ERROR-DIALOG-MESSAGE":"We are afraid that a technical issue is currently preventing you from saving this note. <br>We are working to resolve the issue and apologise in the meantime for the inconvenience caused. <br>We will provide an update via email when more information becomes available."
                    },
                    "MATCHED-RESPONSE-FILES": {
                        "SUCCESS": "Response file matched successfully."
                    },
                    "UNMATCHED-RESPONSE-FILES": {
                        "TITLE": "Unmatched response files",
                        "SEARCH": "Search",
                        "CONTENT": "We have detected <span class=\"badge\">{{ pirate_response_files_count }}</span> unmatched response files. <br><br> Please select a response file from the left and match it to a candidate on the right hand side.",
                        "MISSING-RESPONSE": "Missing response files",
                        "CANDIDATE-NUMBER": "Candidate code",
                        "UNMATCHED": "Unmatched response files",
                        "MATCH-TO": "Match",
                        "SELECT-CANDIDATE": "Match to candidate",
                        "INFO": "Please select a response file to match",
                        "CLOSE": "Close",
                        "CONFIRM": "Confirm",
                        "CANCEL": "Cancel",
                        "CONFIRM-TITLE": "Confirm",
                        "CONFIRM-MESSAGE": "Are you sure you wish to match? <br><br>response file: <strong>{{ response_file }}</strong> <br><br>with <br><br>registered candidate: <strong>{{ candidate }}</strong>",
                        "UNMATCHED-CONFIRM-MESSAGE": "Are you sure you wish to remove<br><br>response file: <strong>{{ response_file }}</strong> <br><br>from <br><br>registered candidate: <strong>{{ candidate }}</strong><br><br>If so, the response file will become available as an \"unmatched response file\" again.",
                        "UNMATCHED-CONFIRM-BTN": "Unmatch Pirate Response File"
                    },
                    "HYBRID-RESPONSE-FILES":{
                        "TITLE": "Restore online response",
                        "TABLE":{
                            "HEADER":{
                                "SESSION-ID": "Session ID",
                                "SESSION-LIFETIME": "Session Lifetime",
                                "TIME-ELAPSED":"Time elapsed"
                            }
                        },
                        "SESSION-LIFETIME-UNKNOWN": "Unknown",
                        "CANCEL":"Cancel",
                        "CLOSE":"Close",
                        "RESTORE":"Restore",
                        "IS-RESTORED":" is restored",
                        "SELECT":"Select",
                        "HAS_BEEN_RESTORED": " has been restored and will be processed soon.",
                        "NO-SESSIONS-FOUND": "No online response data found."
                    },
                    "SUBMIT-WITH-ONLY-BLANK-RESPONSES":{
                        "HEADER": "Warning",
                        "MESSAGE": "All response files received for this candidate are empty.<br/>Submit if you believe the candidate did not enter any response during the exam.<br/>If this is not the case please contact the IB.",
                        "BTN-SUBMIT": "Submit empty response",
                        "BTN-CANCEL": "Cancel"
                    },
                    "SUBMIT-SELECTED-WITH-BLANK-RESPONSES":{
                        "HEADER": "Warning",
                        "MESSAGE": "{{count_successfully}} candidates submitted successfully, {{count_blank}} candidates not submitted as they were found to only have blank response files. Please submit these individually if necessary.",
                        "BTN-SUBMIT": "Ok",
                        "BTN-CANCEL": "Cancel"
                    },
                    "SUBMIT-WITH-ATTENDANCE-ABSENT":{
                        "HEADER": "Warning",
                        "MESSAGE": "This candidate has a response file, but is also flagged as absent and therefore did not sit the assessment.<br/>Please change their attendance status and resubmit, or contact the IB for further assistance if that is not suitable.",
                        "BTN-SUBMIT": "Ok",
                        "BTN-CANCEL": "Cancel"
                    }
                }
            }
        },
        "AUTH": {
            "REGISTRATION": "Registration",
            "SAVE": "Save",
            "LOGIN-FAILED": "Invalid login credentials."
        },
        "PROGRESS": {
            "LOGGED_IN": "Logged in",
            "SCHOOL_DATA": "Reading school data"
        },
        "MODEL": {
            "CANDIDATEATTENDANCE": {
                "ABSENT": "Absent",
                "ATTENDED": "Attended",
                "UNKNOWN": "Unknown"
            },
            "CANDIDATEREGISTRATION": {
                "FULLNAME": "{{ first_name}} {{ last_name }}",
                "TOSTRING": "{{ fullname }}, {{ date }}, {{ number }}"
            }
        },
        "LOGIN": {
            "HEADLINE": "Admin Console",
            "LABELS": {
                "LANGUAGE": "Select language",
                "INVIGILATOR-CODE": "Invigilator code",
                "ADMIN-ACCESS-CODE": "Admin Console code"
            },
            "CONTENT": {
                "LOGGED-HEADLINE": "Logged in",
                "NOT-LOGGED": "You are not currently logged in.",
                "LOGGED": "This is the start screen. Use the menu on the top left to navigate."
            },
            "LOGIN-BTN": "Login",
            "LOGIN-BTN-LOADING": "Logging in"
        },
        "COMPCHECK": {
            "LIST-POPOVER-TITLE": "Compatibility Checker Results ({{count}})",
            "LIST-POPOVER":       "Failed:{{results.failed}}, Warning:{{results.warning}}, Passed:{{results.passed}}",
            "LIST":               {
                "TITLE": "Compatibility Checker Results",
                "GRID": {
                    "COMPUTER-NAME":           "Computer-Name",
                    "TSTAMP":                  "Created",
                    "TOTAL-COMPCHECKRESPONSE": "# Test Runs",
                    "TOTAL-COMPCHECKRESULTS":  "# Test Results",
                    "RESULT":                  "Result",
                    "RESULT-FAILED":           "# Failed",
                    "RESULT-WARNING":          "# Warning",
                    "RESULT-PASSED":           "# Passed",
                    "TIME":                    "Time Taken",
                    "NAME":                    "User-Name",
                    "EMAIL":                   "E-Mail"
                }
            },
            "FILTER":             {
                "RESULT-LABEL":   "Filter",
                "SEARCH-LABEL":   "Search",
                "DEFAULT-FILTER": "All"
            },
            "RESULT-DETAILS":     {
                "HEADLINE":                 "Results Details",
                "PANEL-TITLE":              {
                    "PASSED":  "Passed",
                    "FAILED":  "Failed",
                    "WARNING": "Warning"
                },
                "TAB-HEADLINE":             {
                    "USER-INPUT": "User Input",
                    "SELF-TEST":  "Self Test",
                    "USER-TEST":  "User Test"
                },
                "TIME":                     "Time:",
                "TIME-VALUE":               "{{time}}s",
                "FAIL-MESSAGE":             "Fail-Message:",
                "UNEXPECTED-ERROR-MESSAGE": "Unexpected Error Message:",
                "DATA":                     "Data",
                "LANGUAGE-DATA":            "Language-Data"

            },
            "RESULT-STATUS":      {
                "PASSED":  "Passed",
                "FAILED":  "Failed",
                "WARNING": "Warning"
            },
            "ERROR":              {
                "REQUEST": {
                    "TITLE":   "Request Error",
                    "MESSAGE": "Server Message: {{error}}"
                }
            }
        }
    },
    "COLOR-THEME": {
        "DEFAULT": "Default",
        "LIGHT-YELLOW": "Light yellow",
        "BLUE": "Blue",
        "YELLOW": "Yellow",
        "PINK": "Pink",
        "GREY": "Grey",
        "OFF-WHITE": "Off white",
        "BLACK": "Black"
    },
    "CMS": {
        "LOGIN": {
            "HEADLINE": "Development system",
            "CONTENT": [
                "<strong>Candidate unlock is disabled in development system. Please contact a system administrator.</strong>"
            ]
        },
        "WRAP-AND-DEPLOY-LIST": {
            "HEADLINE": "Wrap and Deploy",
            "NGGRID-LABEL": {
                "ASSESSMENT-TITLE": "Assessment Title",
                "PAPER-CODE": "Paper Code",
                "SESSION": "Session",
                "SUBJECT": "Subject",
                "LANGUAGE-NAME": "Language",
                "TYPE": "Type",
                "CONTENT-VERSION": "Content Version (current)",
                "LAST-PUBLISHED-DATE": "Last Published",
                "LAST-PUBLISHED-BY": "Last Published By",
                "LAST-PUBLISHED-VERSION": "Last Published Version",
                "LAST-PUBLISHED-TYPE": "Last Published Type",
                "JOB-STATUS": "Last Publication Status",
                "AVAILABLEWD": "Available in W&D"
            },
            "AVAILABLEWD": "Is Available",
            "UNAVAILABLEWD": "Is Unavailable"
        },
        "WRAP-AND-DEPLOY-DETAILS-OVERVIEW": {
            "HEADLINE": "Assessment: {{s1}} (Session: {{s2}})",
            "HEADLINE-NO-SESSION": "Assessment: {{s1}}"
        },
        "WRAP-AND-DEPLOY-HISTORY": {
            "HEADLINE": "Publishing Status & History",
            "NGGRID-LABEL": {
                "ID": "ID",
                "PUBLISHED-DATE": "Date Published",
                "PUBLISHED-BY": "Published By",
                "PACKAGE-TYPE": "Package Type",
                "AESSESSMENT-VERSION": "Assessment Version",
                "BUNDLES-TOTAL": "# Package Bundles (Total)",
                "BUNDLES-GENERATED": "# Package Bundles (Generated)",
                "AVAILABLE-ON-IBIS": "Available on IBIS",
                "STATUS": "Status"
            }
        },
        "WRAP-AND-DEPLOY-DETAILS": {
            "HEADLINE": "Details for Publication ID {{s1}}",
            "NGGRID-LABEL": {
                "ID": "Package Bundle Job ID",
                "SCHOOL": "School",
                "SCHOOLCODE": "School Code",
                "STATUS": "Status",
                "CREATED": "Created"
            },
            "STATUS": {
                "INPROGRESS": "In Progress",
                "COMPLETED": "Completed",
                "FAILURE": "Failed {{failed}}"
            }
        },
        "EXPORT-IBIS-MS": {
            "HEADLINE": "IBIS Mark Structure",
            "FORMS": {
                "SEARCH": {
                    "NO-LANG-CODE-LABEL": "Search:",
                    "INPUT-PLACEHOLDER": "No Language Code"
                }
            },
            "GRID": {
                "SEARCH-LIST": {
                    "COLS": {
                        "SUBJECT": "Subject",
                        "NO-LANG-CODE": "No Lang Code",
                        "YEAR": "Year",
                        "MONTH": "Month",
                        "PUBLISH-STATUS": "Publication Status",
                        "IBIS-PROCESSED-STATUS": "IBIS Processing Status"
                    }
                }
            },
            "COMPARISON": {
                "HEADLINE": "IBIS Mark Structure Comparison",
                "TOOLTIP": {
                    "MARKS-DIFFERS": "Marks differs:<br>Given <strong>{{ s1 }}</strong> instead of <strong>{{ s2 }}</strong>",
                    "QIG-DIFFERS": "QIG differs:<br>Given <strong>{{ s1 }}</strong> but it should be <strong>{{ s2 }}</strong>",
                    "ITEM-NOT-FOUND": "This element does not exist in at least one of other the Mark Scheme Structures displayed."
                },
                "PUBLISH-BTN-LABEL": "Publish MS",
                "PUBLISH-BTN-DISABLED-VALIDATION-ERROR": "This Mark Structure cannot be exported currently due to validation errors. Please refer to the table below for details.",
                "PUBLISH-BTN-DISABLED-BEING-PROCESSED": "This Mark Structure is already being processed. Please wait and try again later.",
                "PUBLISH-BTN-DISABLED-ALREADY-PUBLISHED": "This Mark Structure has been already exported.",
                "PUBLISH-BTN-DISABLED-MISSING-ASSESSMENTS": "This Mark Structure cannot be exported due missing Assessments.",
                "REVOKE-BTN-LABEL": "Revoke MS",
                "REVOKE-BTN-DISABLED-UNPUBLISHED-STATUS": "This Mark Structure cannot be revoked because it has never been published so far.",
                "REVOKE-BTN-DISABLED-ALREADY-REVOKED": "This Mark Structure has not been published again.",
                "CANNOT-READ-PUBLISH-STATUS": "Error! Could not read the Assessment's publication status.",
                "PUBLISHING-STATUS": "Publishing Status",
                "MISSING-ASSESSMENTS": "Attention! The current Mark Structure should also include a version for {{ s1 }} language!",
                "IBIS-PROCESSED": "IBIS Processed",
                "IBIS-STATUS": "IBIS Status",
                "IBIS-PROCESSING-ERROR": "IBIS Processing Error",
                "AT": "at",
                "YES": "Yes",
                "NO": "No"
            }
        },
        "NAVBAR": {
            "SAVING-BUSY": "Saving your changes..."
        },
        "CREATE": {
            "HEADLINE": "Create eAssessment",
            "PAPER-NGGRID-LABEL": {
                "NAME": "Paper Code",
                "YEAR": "Year",
                "MONTH": "Month",
                "SUBJECT": "Subject",
                "LANGUAGE-NAME": "Language",
                "COMPONENT": "Component"
            },
            "ACCORDION": {
                "HEADLINE01": "Connect to IBIS Papercode",
                "HEADLINE02": "Create IBIS-independant eAssessment"
            },
            "OPTION-DEFAULT": {
                "TYPE": "Select Type",
                "TITLE": "Title",
                "SUBJECT": "Select Subject",
                "SESSION": "--All Sessions --",
                "LANGUAGE": "Select System - Language",
                "SYSTEM-LANGUAGE-SELECTABLE": "System - Language is selectable by candidate",
                "INPUT-LANGUAGE": "Select Input - Language",
                "INPUT-LANGUAGE-01": "Select Input - Language",
                "INPUT-LANGUAGE-02": "Same as System - Language",
                "CUSTOM-MARK-LABEL": "Custom Mark - Label",
                "CUSTOM-MARKS-LABEL": "Custom Marks - Label",
                "TOTAL-MARKS-LABEL": "Total Marks",
                "SPELLCKER-LANGUAGE": "Select Spellchecker-Language",
                "WRITING-DIRECTION": "Writing Direction",
                "COMPONENT": "Select Component",
                "PAPER": "Select Paper",
                "BEGIN": "Begin",
                "EXPIRE": "Expire",
                "COMMENT": "Comment",
                "INVIGILATOR-CODE": "Invigilator-Code",
                "SHORT-TITLE": "Short Title",
                "SHORT-LABEL": "Short Label",
                "STATUS": "Select Status"
            },
            "INFO": {
                "EASSESSMENT-EXISTS": "eAssessment already exists",
                "REQUIRED-INFO": "Required field must not be blank"
            },
            "ERROR": {
                "EMPTY-TITLE": "This field cannot be blank!",
                "EMPTY-LANGUAGE": "Select Language",
                "EMPTY-MARK": "This field cannot be blank!",
                "EMPTY-MARKS": "This field cannot be blank!",
                "EMPTY-TOTAL-MARKS": "This field cannot be blank!"
            }
        },
        "ASSESSMENT-LIST": {
            "HEADLINE": "eAssessment List",
            "SEARCH-PLACEHOLDER": "Enter your search query here",
            "ASSESSMENT-NGGRID-LABEL": {
                "TITLE": "Title",
                "SESSION": "Session",
                "PAPER-NAME": "Paper Code",
                "COMMENT": "Comment",
                "TYPE": "Type",
                "LANGUAGE": "Language",
                "VERSION": "Version",
                "LOCKED": "Locked"
            },
            "EDIT-ASSESSMENT-PROPERTIES": {
                "HEADLINE": "Edit Properties"
            },
            "DELETE-ASSESSMENT": {
                "HEADLINE": "Delete Assessment",
                "INFO": "Are you sure you want to delete the Assessement?"
            },
            "CLONE-ASSESSMENT": {
                "HEADLINE": "Clone Assessment"
            },
            "TYPEFILTER-NONIBIS": "<Any non-IBIS Assessment>",
            "TYPEFILTER-IBIS": "<Any IBIS Assessment>"
        },
        "LAYOUT-MANAGER": {
            "LABEL": {
                "ROW": "Row Element {{i}}",
                "COL": "Col Element {{i}}",
                "CONTAINER-CHANGED": "Container properties changed",
                "STICKY": "Activate Sticky Option"
            },
            "EMPTY-TASK": {
                "HEADLINE": "You have created a new empty assessment",
                "CONTENT": [
                    "<br/>No questions have been added so far.<br>Please use the \"Create new question\" button to get started."
                ]
            },
            "EMPTY-ROW": "This is a empty row, you need to drag a column into it.",
            "EMPTY-COL": "This is a empty column, you need to add a container to add content objects to it.",
            "EMPTY-CONTAINER": "This is a empty container, you can drag objects into this",
            "WARNING-MESSAGES": {
                "DELETE": "This container is not empty, it contains content.<br>Are you sure you want to delete it.",
                "01": "WARNING (1): Order is wrong (proposition : choose a permitted questionpart or put <strong>\"{{s1}}\"</strong> in new Row)",
                "02": "WARNING (2): Row error (proposition : choose a permitted questionpart or put Question-Parts <strong>\"{{s1}}\"</strong> in new Row)",
                "03": "WARNING (3): Order is wrong (proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row)",
                "04": "WARNING (4): Order is wrong (proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row)",
                "05": "WARNING (5): Order is wrong (proposition : choose a permitted questionpart, put <strong>\"{{s1}}\"</strong> in new Row or put after <strong>\"{{s2}}\"</strong>)",
                "06": "WARNING (6): Order is wrong (proposition : choose a permitted questionpart or put <strong>\"{{s1}}\"</strong> in new Row or put <strong>\"{{s2}}\"</strong> after <strong>\"{{s3}}\"</strong>)",
                "07": "WARNING (7): Order is wrong (proposition : choose a permitted questionpart or put <strong>\"{{s1}}\"</strong> in new Row)",
                "08": "WARNING (8): Order is wrong (proposition : choose a permitted questionpart (for example <strong>\"{{s1}}\"</strong>))",
                "09": "WARNING (9): Order is wrong (proposition : choose a permitted questionpart or put before <strong>\"{{s1}}\"</strong>)",
                "MAX-ELEMENT": "Max element!",
                "EXCLUDE-OBJECT": "Not Allowed"
            },
            "INFO-MESSAGES": {
                "01": "INFO (1): proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row",
                "02": "INFO (2): proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row",
                "03": "INFO (3): proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row",
                "04": "INFO (4): proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row",
                "05": "INFO (5): proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row",
                "06": "INFO (6): proposition: put all Question-Parts <strong>\"{{s1}}\"</strong> in same row",
                "VALID-PLACE": "find valid place !"
            },
            "HEADLINE": {
                "LOADING": "Loading...",
                "TAB-PREFERENCES": "Tab Preferences",
                "CAROUSEL-PREFERENCES": "Carousel Preferences",
                "DELETE-TAB": "Delete Tab",
                "DELETE-SLIDE": "Delete Slide",
                "WARNING": "Warning",
            },
            "TOOLTIP": {
                "ROW": {
                    "TRASH": "Delete (Row)",
                    "ARROW-UP": "Up (Row)",
                    "ARROW-DOWN": "Down (Row)",
                    "MOVE": "Move (Row)"
                },
                "COL": {
                    "TRASH": "Delete (Col)",
                    "MOVE": "Move (Col)"
                },
                "CONTAINER": {
                    "TRASH": "Delete (Container)",
                    "ARROW-UP": "Up (Container)",
                    "ARROW-DOWN": "Down (Container)",
                    "MOVE": "Move (Container)"
                },
                "COPIED-CONTAINER": {
                    "TRASH": "Delete (Container)",
                    "COPY": "Copy (Container)",
                    "CLEAR-CLIPBOARD": "Remove all copied containers from the clipboard",
                    "RELOAD-CLIPBOARD": "Reload content from the clipboard",
                    "ARROW-UP": "Up (Container)",
                    "ARROW-DOWN": "Down (Container)",
                    "MOVE": "Move (Container)"
                },
                "OBJECT": {
                    "TRASH": "Delete (Object)",
                    "ARROW-UP": "Up (Object)",
                    "ARROW-DOWN": "Down (Object)",
                    "MOVE": "Move (Object)"
                },
                "CONTAINER-PREFS": "Edit Container Preferences",
                "PREFS": "Edit Object Preferences",
                "EDIT": "Edit Object",
                "CONFIRM": "Confirm Object",
                "RESET": "Reset Object",
                "BROWSE-MEDIA": "Browse Media"
            },
            "NEW-ELEMENT": {
                "ROW": {
                    "LABEL": "New Row",
                    "DESCRIPTION": "New Row description"
                },
                "COL": {
                    "LABEL": "New Col",
                    "DESCRIPTION": "New Col description"
                },
                "CONTAINER": {
                    "LABEL": "New Container",
                    "DESCRIPTION": "New Container description"
                },
                "IAA-CONTAINER": {
                    "LABEL": "New IAA-Container",
                    "DESCRIPTION": "New IAA-Container description"
                },
                "CAROUSEL-CONTAINER": {
                    "LABEL": "New Carousel Container",
                    "DESCRIPTION": "New Carousel description"
                },
                "TAB-CONTAINER": {
                    "LABEL": "New Tab Container",
                    "DESCRIPTION": "New Tab description"
                }

            },
            "COPIED-ELEMENT": {
                "CONTAINER": {
                    "LABEL": "Copied Container",
                    "DESCRIPTION": "Copied Container from {{taskTitle}}"
                },
                "IAA-CONTAINER": {
                    "LABEL": "Copied IAA-Container",
                    "DESCRIPTION": "Copied IAA-Container description"
                },
                "CAROUSEL-CONTAINER": {
                    "LABEL": "Copied Carousel Container",
                    "DESCRIPTION": "Copied Carousel description"
                },
                "TAB-CONTAINER": {
                    "LABEL": "Copied Tab Container",
                    "DESCRIPTION": "Copied Tab description"
                }

            },
            "NEW-OBJECT": {
                "RESPONSE-SHORT-TEXTBOX": {
                    "LABEL": "Response Short Textbox",
                    "DESCRIPTION": "Short candidate text response"
                },
                "GEOGEBRA": {
                    "LABEL": "GeoGebra Object",
                    "DESCRIPTION": "GeoGebra Object for candidates"
                },
                "RESPONSE-TEXTBOX": {
                    "LABEL": "Response Textbox",
                    "DESCRIPTION": "Long candidate text responses"
                },
                "HINT-OBJECT": {
                    "LABEL": "Hint Object",
                    "DESCRIPTION": "Hint option for candidates"
                },
                "TEXT": {
                    "LABEL": "Text Object",
                    "DESCRIPTION": "Static Text"
                },
                "TEXT-MCQ": {
                    "LABEL": "Text/MCQ/Mini-Cloze Object",
                    "DESCRIPTION": "Text with MCQ/Mini-Cloze Response Input"
                },
                "TEXT-CK5": {
                    "LABEL": "CK5 Stimulus Object",
                    "DESCRIPTION": "Static Text"
                },
                "RESPONSE-TEXTBOX-CK5": {
                    "LABEL": "CK5 Response Textbox",
                    "DESCRIPTION": "Long candidate text responses"
                },
                "IMAGE": {
                    "LABEL": "Image Object",
                    "DESCRIPTION": "Image content"
                },
                "VIDEO": {
                    "LABEL": "Video Object",
                    "DESCRIPTION": "Video Playback"
                },
                "AUDIO": {
                    "LABEL": "Audio Object",
                    "DESCRIPTION": "Audio Playback"
                },
                "TABLE": {
                    "LABEL": "Table Object",
                    "DESCRIPTION": "Candidate-created table response"
                },
                "UNIVERSAL-CANVAS": {
                    "LABEL": "Universal Canvas Object",
                    "DESCRIPTION": "Universal Canvas - allows candidate sto paint a response"
                },
                "WIRIS": {
                    "LABEL": "Equation Editor",
                    "DESCRIPTION": "Wiris - Candidate editable equation"
                },
                "WIRIS-STIMULUS": {
                    "LABEL": "Equation Stimulus",
                    "DESCRIPTION": "Wiris - Stimulus equation content"
                },
                "SCATTER-GRAPH": {
                    "LABEL": "Scatter Graph Object",
                    "DESCRIPTION": "Hand drawn Scatter Graph"
                },
                "MEASUREMENT-OBJECT": {
                    "LABEL": "Measurement Object",
                    "DESCRIPTION": "Measurement Object - allows candidates to make measurements on an image"
                },
                "IFRAME": {
                    "LABEL": "IFrame Object",
                    "DESCRIPTION": "Custom HTML content"
                },
                "AUTO-PLOT": {
                    "LABEL": "Auto Plot Object",
                    "DESCRIPTION": "Plot a table"
                }
            },
            "OBJECT-HEADER": {
                "EDIT": "Edit",
                "CONFIRM": "Confirm",
                "PREFS": "Prefs",
                "MOVE-TO-TAB": "Move to Tab",
                "BROWSE-MEDIA": "Browse media",
                "BROWSE-PALETTES": "Browse palettes",
                "BROWSE-BACKGROUND-IMAGES": "Select Background-Images",
                "ADD-SUBTITLE": "Add Subtitle",
                "REMOVE-SUBTITLE": "Remove Subtitle",
                "UPLOAD-NEW-MEDIA": "Upload new media",
                "RESET": "Reset",
                "PREFERENCES": "Preferences",
                "CHANGED": "Changed",
                "ADD-BACKGROUND": "Add Background-Image",
                "REMOVE-BACKGROUND": "Remove Background-Image",
                "PREFERENCES-CANDIDATE": "Candidate View Settings",
            },
            "GROUPS": {
                "1": "Basic Objects",
                "2": "Media Objects",
                "3": "Advanced Objects"
            }
        },
        "COPY-CONTAINER-MANAGER": {
            "HEADLINE": {
                "INFO": "Settings for the copied container",
                "OVERWRITE": "Container already copied",
                "COPY-CODE": "Copied Container",
            },
            "BTN": {
                "SAVE": "Apply",
                "CANCEL": "Cancel",
                "CONTINUE": "Continue"

            }
        },
        "MEDIA-MANAGER": {
            "TITLE": "Media Manager for {{s1}}",
            "UPLOADER": {
                "TITLE": "Media Manager for",
                "BUTTONS": {
                    "ADD-FILES": "Add files...",
                    "UPLOAD-ALL-FILES": "Upload All Files",
                    "CANCEL-ALL-FILES": "Cancel All Files",
                    "UPLOAD": "Upload",
                    "CANCEL": "Cancel"
                },
                "NO-FILES-SELECTED": "No files selected for upload",
                "NO-FILES-SELECTED-ADVICE": "Please add files using the button above or just use your favourite file explorer tool and drop a file into this zone"

            },
            "BROWSER": {
                "TITLE": "Media Manager Browser",
                "USED-IN": "Used in question(s):",
                "MODAL": {
                    "HEADLINE": "Media Browser"
                },
                "REFERENCES": {
                    "SEE": "See references",
                    "TITLE": "Active References",
                    "QUESTIONS": "Question(s):",
                    "PALETTES": "Palette(s):",
                    "OVERVIEW": "Overview:",
                    "IN-OVERVIEW": "Yes",
                    "IFRAME-ICON": "Iframe Icon:",
                    "IFRAME-TOOL": "Iframe(s):",
                    "IN-IFRAME-TOOL": "Yes",
                    "VIDEO-SUBTITLE": "Video:",
                    "AUDIO-BACKGROUND": "Audio:"
                },
                "NO-FILES-YET": "This assessment does not contain any media content yet.",
                "NO-FILES-YET-ADVICE": "You can use the 'Add files' button above to add some files into this eAssessment",
                "NO-FILES-OF-TYPE": "There're no files of type <strong>{{mediaFilterType}}</strong> to be shown.",
                "FILTER": {
                    "TITLE": "Active Filter :",
                    "IMAGE": "Image",
                    "VIDEO": "Video",
                    "AUDIO": "Audio",
                    "SUBTITLE": "Subtitle",
                    "IFRAME": "Iframe Content",
                    "GEOGEBRA": "Geogebra",
                    "NO-FILTER": "No Filter"
                },
                "REPLACE": {
                    "TITLE": "Replace Media",
                    "CANNOT-REPLACE": "You cannot replace <strong><span title=\"{{target1}}\">{{target2}}</span></strong> with <strong><span title=\"{{source1}}\">{{source2}}</span></strong>, because the target file has active references.",
                    "WANT-TO-REPLACE": "Do you want to replace <strong><span title=\"{{target1}}\">{{target2}}</span></strong> with <strong><span title=\"{{source1}}\">{{source2}}</span></strong> ?",
                    "YES-REPLACE-IT": "Yes, replace it!"
                },
                "BUTTONS": {
                    "DELETE-FILE-LIST": "Delete selected files",
                    "DELETE-CANCEL": "Discard selection"
                },
                "CONFIRM": {
                    "DELETE-MULTIPLE-FILES": "Are you sure to delete this files?"
                }
            },
            "INFO-WINDOWS": {
                "UPLOAD": {
                    "ERROR": {
                        "TITLE": "Warning",
                        "SINGLE-SELECTION": {
                            "MESSAGE": "Cannot upload <strong><span title=\"{{s1}}\">{{s2}}</span></strong>, its filetype is not allowed."
                        },
                        "MULTIPLE-SELECTION": {
                            "MESSAGE": "The following files cannot be uploaded, because their filetypes are not allowed:"
                        },
                        "MESSAGE": "Cannot upload file {{s1}}",
                        "FILE-NOT-ALLOWED": "File type not accepted",
                        "DETAILS": "<ul>Please upload only:<li>Image: <strong>Jpg, Gif, Png</strong> or <strong>Svg</strong></li><li>Video: <strong>Mp4</strong>, <strong>Avi</strong>, <strong>Asf</strong>, <strong>Mov</strong> or <strong>Webm</strong></li><li>Audio: <strong>Mp3</strong></li><li>Subtitle: <strong>Srt</strong></li></ul>"
                    }
                },
                "DELETE": {
                    "ERROR": {
                        "TITLE": "Hint",
                        "RESULT-SINGLE-FILE": "Cannot deleted <strong><span title=\"{{s1}}\">{{s2}}</span></strong>, because it has active references.",
                        "RESULT-MULTIPLE-FILE": "The following files cannot be deleted, because they have active references:",
                        "CHECK-REFERENCES": "Please undo these references before proceeding with delete operations."
                    }
                }
            },
            "DELETE-CARD": {
                "CONFIRMATION": "Are you sure to delete <strong title=\"{{s2}}\">{{s1}}</strong> ({{s3}})?",
                "REJECT-DELETE": "You cannot delete the file <strong title=\"{{s2}}\">{{s1}}</strong> yet.",
                "IN-USE": "Please check its active references, if you really want to delete it.",
                "BUTTON-CONFIRM": "Yes, delete this file!"
            }
        },
        "UNIVERSAL-CANVAS": {
            "TITLE": "Universal Canvas",
            "PALETTE": {
                "INPUT-LABEL": "Palette name",
                "DROPZONE-HINT": "Drop your images here",
                "CHOOSE-PALETTE": "Choose Palette",
                "BUTTONS": {
                    "ADD-PALETTE": "New Palette",
                    "DELETE-PALETTE": "Delete Palette",
                    "CANCEL": "Cancel",
                    "CONFIRM-AND-CLOSE": "Confirm and close",
                    "CONFIRM-CHANGES": "Confirm Changes"
                }
            }
        },
        "SHEET-STRUCTURE-EDITOR": {
            "HEADLINE": {
                "CREATE": "Create new Question",
                "EDIT-QUESTION-PROPERTIES": "Edit Question Properties",
                "EDIT-QUESTION-PARTS": "Edit Question-Parts",
                "DELETE-QUESTION-PART": "Delete Question-Part",
                "DELETE-QUESTION": "Delete Question",
                "EDIT-QUESTION-ITEM-GROUPS": "Edit Question Item Groups",
                "CREATE-PRE-RELEASE": "Create Pre-Release",
                "EDIT-PRE-RELEASE": "Edit Pre-Release",
                "CREATE-JOURNAL": "Create Journal",
                "EDIT-JOURNAL": "Edit Journal",
                "DELETE-PRE-RELEASE": "Delete Pre-Release",
                "DELETE-JOURNAL": "Delete Journal"
            },
            "INPUT": {
                "QUESTION-NUMBER": {
                    "LABEL": "Specify Question Number:"
                },
                "CUSTOM-SHEET-NAME": {
                    "LABEL": "Define a custom Sheet Label:"
                },
                "NOT-DIVIDED-INTO-QUESTION-PARTS": {
                    "LABEL": "This question is not divided into Question Parts",
                    "INFO": "For questions not divided into question parts, you just need to specify the number of marks applicable.",
                    "NUMBER-OF-MARKS": "Number of marks applicable"
                },
                "DIVIDED-INTO-QUESTION-PARTS": {
                    "LABEL": "This question is divided into Question Parts",
                    "INFO": "You can now setup one or multiple question parts by entering their name and number of marks applicable into the table below. Whenever you add a new row, another blank row will appear."
                },
                "JOURNAL": {
                    "LABEL": "Label"
                },
                "PRE-RELEASE": {
                    "LABEL": "Label"
                }
            },
            "QUESTION-PROPERTIES": {
                "CONTENT": []
            },
            "QUESTION-PARTS": {
                "CONTENT": [
                    "You need to specify whether you want the question to multiple \"Question Parts\".",
                    "These \"Question Parts\" divide the question into multiple units with a separate value for \"marks applicable\".",
                    "*If you're not sure which option to choose now, please be aware that you can change this at any time*"
                ],
                "LIST": {
                    "HEADLINE": {
                        "QUESTION-PART-NUMBER": "Question Part Number",
                        "LABEL": "Label",
                        "MARKS": "Marks",
                        "QIGS": "Question Item Groups",
                        "QIGS-USED": "Used in Question-Parts"
                    }
                },
                "DEFAULT-LABEL": "Custom Question Label"
            },
            "DELETE-QUESTION-PARTS": {
                "LABEL": {
                    "REASSIGN": "Re-assign content to question part",
                    "DELETE-CONTENT": "Delete existing content",
                    "DELETE-ANY-EMPTY-ROWS": "Delete any rows which would become empty"
                },
                "WARNING": {
                    "REALLY-DELETE": "Do you really want to delete",
                    "NOT-ALLOWED": "You must have a Question-Part. Delete not allowed!"
                },
                "INFO": {
                    "USED-IN": "Is used in {{s}} Container"
                }
            },
            "WARNING": {
                "QUESTION-SHORT-TITLE": "1-99",
                "QUESTION-SHORT-TITLE-NUMBER": "Is not number",
                "QUESTION-SHORT-TITLE-EXISTS": "Question Short-Title exists",
                "QUESTION-TITLE-EMPTY": "Is empty",
                "QUESTION-PART-TITLE-EMPTY": "Question-Part is empty",
                "QUESTION-PART-SHORT-TITLE-NUMBER": "Is not number",
                "QUESTION-PART-SHORT-TITLE-EXISTS": "Question-Part Short-Title exists",
                "MARKS-NUMBER": "Please enter a number",
                "MARKS-MAX": "Maximum Number 999",
                "MARKS-MIN": "Minimum Number 0",
                "IS-NOT-VALID": "Is not valid"
            },
            "QUESTION-ITEM-GROUP": {
                "DEFAULT-TITLE": "Question Item Group 01 (Default QIG)",
                "DEFAULT-LABEL": "Default QIG",
                "TITLE": "Question Item Group {{s1}}",
                "ERROR": {
                    "EMPTY-TITLE": "Title is empty",
                    "MIN-TITLE-LENGTH": "4 characters minimum",
                    "MAX-TITLE-LENGTH": "40 characters maximum"
                }
            },
            "CONTAINER-HEADER": {
                "HEADLINE": "Preferences",
                "QUESTION-PART": {
                    "LABEL": "Question-Part"
                },
                "EXPANDABLE": {
                    "LABEL": {
                        "EXPANDABLE": "Expandable",
                        "EXPANDABLE-WIDTH": "Expandable to width"
                    }
                },
                "ALLOW-BOOKMARKING": "Bookmarking"
            },
            "CRITERION": {
                "HEADER": "Edit / Add Criterion",
                "TABLE-HEAD-CRITERION": "Criterion",
                "TABLE-HEAD-USED-IN": "Used in Question-Parts",
                "BTN": {
                    "ADD-CRITERION": "Add new Criterions",
                    "ADD-EDIT-CRITERION": "Add / Edit Criterion",
                    "AMEND-CRITERION": "Amend Criterion Marks",
                    "SETUP-CRITERION": "Setup Criterion Marks"
                }
            },
            "CRITERIONMARKS": {
                "HEADER": "Edit / Add Criterion Marks",
                "TABLE-HEAD-MARKS": "Mark",
                "TABLE-HEAD-CRITERION": "Criterion",
                "ERROR-MESSAGE": {
                    "CREATE-CRITERION": "Please Create Criterions",
                    "SELECT-CRITERION": "Select Criterion for #{{s}}",
                    "EMPTY-MARKS": "Marks is empty for #{{s}}",
                    "DUPLICATE-CRITERION": "Duplicate Criterion \"{{s}}\""
                },
                "BTN": {
                    "ADD-CRITERIONMARKS": "Add new Criterion-Mark"
                }
            },
            "TOOLTIP": {
                "EDIT-QUESTION": "Edit Question",
                "EDIT-PRE-RELEASE": "Edit Pre-Release",
                "EDIT-JOURNAL": "Edit Journal",
                "ADD-PREVIEW-IMAGE": "Add Preview-Image",
                "OPEN-SHEET": "Open Question",
                "OPEN-PRE-RELEASE": "Open Pre-Release",
                "OPEN-JOURNAL": "Open Journal",
                "DELETE-SHEET": "Delete Question",
                "DELETE-PRE-RELEASE": "Delete Pre-Release",
                "DELETE-JOURNAL": "Delete Journal",
                "DELETE-QUESTION-PART": "Delete Question-Part",
                "MOVE-UP-SHEET": "Move up",
                "MOVE-DOWN-SHEET": "Move down",
                "SORT-SHEET": "Drag & Drop to change order"
            }
        },
        "VERSIONING": {
            "HEADLINE": {
                "TAGNEWVERSION": "Tag as new Version",
                "LOCKVERSION": "Lock as Version",
                "UNLOCKVERSION": "Unlock Version",
                "AVAILABLEWD": "Make available in W&D",
                "UNAVAILABLEWD": "Make unavailable in W&D",
                "AUDITLOG": "Audit Log"
            },
            "LABEL": {
                "EXISTINGVERSION": "Existing Version:",
                "NEWVERSION": " New Version:"
            },
            "LOCKED-CONTENT": [
                "<h3>Assessment Locked</h3><hr>",
                "This assessment is locked! <br/><strong>No changes can be saved currently.</strong><br/><br/>If you need to make further changes, please unlock this assessment first, but please note that this will make the assessment unavailable to wrap&amp;deploy!"
            ],
            "LOCKNEWVERSION-CONTENT": [
                "Publishing will make the Assessment available in Wrap&Deploy.",
                "Also, the assessment will be *locked* and can no longer be edited.",
                "If you need to make changes after this you need to \"unlock\"."
            ],
            "UNLOCKVERSION-CONTENT": [
                "This assessment is currently locked.",
                "Unlocking it will make it *unavailable to wrap&deploy*, no packages can be created unless you lock/publish again."
            ],
            "POPOVER": {
                "SAVE-FIRST": "Please Save first!",
                "CLONE-INPROGRESS":"Asssessment is in clone Process!"
            },
            "ROLLBACK": {
                "HEADLINE": "WARNING",
                "WARNING-TEXT": [
                    "Rolling back to a previous version of the assessment will wipe all intermediate versions, from (and including) the current version upto the rollback version.",
                    "Eg if the current version is 0.5.0, and you roll back to version 0.2.0, then versions 0.3.0, 0.4.0 & 0.5.0 will be wiped.",
                    "Please add a comment/description in the box below to justify rolling back."
                ],
                "CONFIRM-TEXT": [
                    "To confirm that you wish to rollback please type 'OK' in the space on the red Rollback button below.",
                    "Then click on the button to rollback."],
                "PLACEHOLDER": {
                    "COMMENT": "Descriptive Text / Comment",
                    "ROLLBACK-BTN": "OK"
                }
            }
        },
        "CLONE-PROCESS": {
            "NOTIFICATION": {
                "INPROGRESS": {
                    "TITLE":   "Clone Inprogress",
                    "MESSAGE": "Assessment <strong>\"{{ title }}\"</strong> is in Clone-Process"
                },
                "COMPLETED":{
                    "TITLE":"Clone-Process Completed",
                    "MESSAGE":"Clones-Process for Assessment <strong>\"{{ title }}\"</strong> is completed"
                },
                "ERROR":{
                    "TITLE":"Clone-Process has Error",
                    "MESSAGE":"Clones-Process for Assessment <strong>\"{{ title }}\"</strong> has error!"
                },
                "CLEAR-ALL":{
                    "TITLE":"Copied containers",
                    "MESSAGE":"Removed all copied containers from the clipboard.",
                    "DELETE":"Removed all downloaded Media from the Media Manager."
                }
            }
        },
        "COPY-CONTAINER-PROCESS": {
            "NOTIFICATION": {
                "INPROGRESS":{
                    "TITLE":"Copy Container",
                    "MESSAGE":"The media for the copied <strong>\"Container {{ title }}\"</strong> is being processed and uploaded.",
                },
                "COMPLETED":{
                    "TITLE":"Copy Container Process Completed",
                    "MESSAGE":"The copied <strong>\"Container {{ title }}\"</strong> has been added to the clipboard."
                },
                "ERROR":{
                    "TITLE":"Copy Container Process has Error",
                    "MESSAGE":"Copy Container Process <strong>\"{{ title }}\"</strong> has error!"
                }
            }
        },
        "BTN": {
            "CONTINUE": "Continue",
            "DELETE": "Delete",
            "CANCEL": "Cancel",
            "CREATE-NEW-QUESTION": "Create new Question",
            "CREATE-NEW-QUESTION-TITLE": "Create a new Question Sheet. Also allows you to setup Question Parts and QIGs.",
            "CREATE-JOURNAL": "Create Journal",
            "CREATE-JOURNAL-POPOVER": "Create Journal .....",
            "CREATE-JOURNAL-POPOVER-DISABLED": "Create Journal ...DISABLED..",
            "CREATE-PRE-RELEASE": "Create Pre-Release",
            "CREATE-PRE-RELEASE-POPOVER": "Create Pre-Release .....",
            "CREATE-PRE-RELEASE-POPOVER-DISABLED": "Create Pre-Release ...DISABLED..",
            "ADD-QUESTION-PART": "Add new Question-Part",
            "CONFIRM": "Confirm",
            "CONFIRM-CHANGES": "Confirm Changes",
            "SAVE": "Save",
            "SAVE-CHANGES": "Save Changes",
            "QUESTION-PROPERTIES": "Question Properties",
            "QUESTION-PARTS": "Question-Parts",
            "BACK": "Back",
            "CLONE": "Clone",
            "EDIT-ASSESSEMNT-PROPERTIES": "Edit Properties",
            "CLOSE": "Close",
            "OPEN": "Open",
            "MEDIA-MGR": "Media Manager",
            "MEDIA-MGR-TITLE": "Open Media Manager - Manage Images/Audio/Video/Any Resources",
            "COPY-CONTAINER": "Click to download required media",
            "COPY-CONTAINER-TITLE": "Download required media",
            "PREVIEW": "Preview",
            "PREVIEW-TITLE": "Enter Preview Mode, will display what the candidate would see",
            "PREVIEW-EXIT": "Exit Preview",
            "PREVIEW-EXIT-TITLE": "Go back to editing",
            "PDF-PREVIEW": "PDF Preview",
            "SAVE-ASSESSMENT": "Save Changes",
            "SAVE-ASSESSMENT-TITLE": "Save all your outstanding changes to the server",
            "GO-BACK": "Back",
            "GO-BACK-TITLE": "Go back to assessment editing screen",
            "SELECT": "Select",
            "DESELECT": "Deselect",
            "DETAILS": "Details",
            "PUBLISH": "Publish",
            "REBUILD": "Rebuild",
            "PREFERENCES": "Preferences",
            "EDIT-QIG": "Edit Question Item Groups",
            "TAG": "Tag",
            "LOCK": "Lock",
            "UNLOCK": "Unlock",
            "ROLLBACK": "Rollback",
            "AVAILABLEWD": "Make available in W&D",
            "UNAVAILABLEWD": "Make unavailable in W&D",
            "TAGNEWVERSION": "Tag as new Version",
            "LOCKVERSION": "Lock as Version",
            "UNLOCKVERSION": "Unlock Version",
            "EDIT-INSTRUCTIONS-PAGE": "Instructions Page",
            "EDIT-INSTRUCTIONS-PAGE-TITLE": "Lets you edit the intructions page, which is the page just before a candidate begins its assessment",
            "ADD-ASSESSMENT-TYPE": "Add new Type",
            "EXAM-EXPORT":"Exam Export",
            "DOWNLOAD-EXAM-PDF":"Download Exam PDF"
        },
        "EXAM-EXPORT": {
            "RESET-BTN":           "Reset",
            "MODAL-TITEL":         "Exam PDF Export",
            "SETTINGS-LABEL":      "Export settings",
            "SETTINGS":            {
                "show__alternative_content":     "Show IAA alternative content",
                "show__iframe":                  "Show Iframe content",
                "show__media_to_translated":     "Show media relevant for translation",
                "show__text_only":               "Show text objects only",
                "show__video_audio_placeholder": "Show placeholder for video/audio objects",
                "show__origin_layout":           "Allow 2 column layout",
                "show__tooltip":                 "Show Tooltips (as footnotes)",
                "show__journal":                 "Show Journal",
                "show__response_text_object":    "Show Response Text objects (long Response Text-Object)"
            },
            "SETTING-TYPES-LABEL": "Type",
            "SETTING-TYPES":       {
                "PAPER-EXPORT":       "PDF Paper Export",
                "TRANSLATION-EXPORT": "Translation Export"
            },
            "MESSAGES":            {
                "FILE-TRANSLATE":     "This file needs to be translated",
                "SUBTITLE-TRANSLATE": "This Subtitle file needs to be translated"
            },
            "DIALOGS":             {
                "SUCCESS": {
                    "TITLE":   "Success",
                    "MESSAGE": "PDF download success"
                },
                "FAILED":  {
                    "TITLE":   "Failed",
                    "MESSAGE": "Server Message: \"{{error}}\""
                }
            },
            "UC":           {
                "SHAPE-LABEL": "Universal Canvas - Select shape"
            },
            "NOTIFICATION": {
                "INPROGRESS": {
                    "TITLE":   "Generate PDF Inprogress",
                    "MESSAGE": "Generating PDF for Assessment <strong>\"{{ title }}\"</strong> is in process"
                },
                "COMPLETED":  {
                    "TITLE":   "Generate PDF Completed",
                    "MESSAGE": "PDF is generated for Assessment <strong>\"{{ title }}\"</strong>. Please click on download button, to download the PDF-FILE"
                },
                "ERROR":      {
                    "TITLE":   "Generate PDF has Error",
                    "MESSAGE": "Generating PDF for Assessment <strong>\"{{ title }}\"</strong> has error!"
                }
            },
            "POPOVER":      {
                "EXAM-EXPORT-INPROGRESS": "PDF rendering inprogress"
            }
        },
        "VALIDATION-COMPONENT": {
            "MODAL-TITEL":"Validation Error",
            "SUCCESS-TOOPTIP" : "No Validation Errors"
        },
        "FACTORIES": {
            "MODELS": {
                "VALIDATORS": {
                    "BANNER": {
                        "HEADLINES": {
                            "MaxMarksValidator":                        "Marks",
                            "QPResponsePDFValidator":                   "Question Part",
                            "QIGEmptyQPValidator":                      "Question Item Group",
                            "AudioEmptyValidator":                      "Media Audio",
                            "ContainerEmptyValidator":                  "Container",
                            "HintEmptyContentValidator":                "Hint validator",
                            "HintEmptyObjectNameValidator":             "Hint object name",
                            "HintEmptySelectLevelValidator":            "Hint Level",
                            "HintSelectLevelValidator":                 "Hint Level",
                            "IframeEmptyValidator":                     "Media Iframe",
                            "ImageEmptyValidator":                      "Media Images",
                            "MinMarksValidator":                        "Marks",
                            "OrderQuestionPartValidator":               "Question Parts",
                            "OrderSheetValidator":                      "Questions",
                            "QuestionPartMarksValidator":               "Question Parts",
                            "RepositoryEntryValidation":                "Assessment integrity check",
                            "TextEmptyValidator":                       "Text",
                            "TextMCQEmptyValidator":                    "Text MCQ",
                            "VideoEmptyValidator":                      "Media Video",
                            "WirisstimulusEmptyValidator":              "Wiris Stimulus",
                            "ResponseShortTextboxResponsePDFValidator": "Response Short Textbox",
                            "ResponseTextboxResponsePDFValidator":      "Response Textbox",
                            "AutoplotTargetValidator":                  "Autoplot Target"
                        },
                        "MORE-INFO-LABEL":"More informations"
                    },
                    "EMPTY": {
                        "AUDIO": "The Audio object is still empty in \"{{s}}\"",
                        "IMAGE": "The Image object is still empty in \"{{s}}\"",
                        "VIDEO": "The Video object is still empty in \"{{s}}\"",
                        "WIRIS-STIMULUS": "The Wiris Stimulus object is still empty in \"{{s}}\"",
                        "TEXT": "The Text object is still empty in \"{{s}}\"",
                        "TEXT-MCQ": "The Text MCQ object is still empty",
                        "IFRAME": "The IFrame object is still empty",
                        "QIG-QP": "\"{{s}}\" does not contain a question part",
                        "CONTAINER": "A Container-Object is still empty in \"{{s}}\"",
                        "HINT": "The Hint object in \"{{s}}\" still needs to be associated to a Text object",
                        "HINT-SELECT-LEVEL": "The Hint object in \"{{s}}\" has no level selected yet",
                        "HINT-OBJECT-NAME": "The Hint object in \"{{s}}\" has no name yet"
                    },
                    "LOGIC": {
                        "HINT-SELECT-LEVEL": "The Hint object in \"{{s}}\" has a level ordering error. Eg.: this could happen if you select a level 2 without having selected a level 1",
                        "MIN-MARKS": "The eAssessment does not match the maximum marks requirement. The maximum marks should be {{maxMarks}}.",
                        "MAX-MARKS": "The eAssessment does not match the maximal marks requirement of {{maxMarks}}",
                        "ORDER-QUESTION-PART": "There is a problem in the sorting of the Question Parts \"{{s}}\"",
                        "ORDER-QUESTION-PART-MORE-INFO": "The order of the Question Parts: \"{{s}}\"",
                        "ORDER-SHEET": "There is a problem in the sorting of the questions",
                        "ORDER-SHEET-MORE-INFO": "The order of the Questions: \"{{s}}\"",
                        "QP-RESPONSE-PDF": "\"{{s}}\" must have a object, that have checked the 'include in PDF' option",
                        "QP-NOT-USED": "Question-Part \"{{s}}\" not used",
                        "QP-MARKS": "\"{{s}}\" does not have marks defined",
                        "RESPONSE-TEXTBOX-PDF": "The Response Textbox in \"{{s}}\" is not being included in PDF file",
                        "RESPONSE-SHORT-TEXT-PDF": "The Response Short Textbox in \"{{s}}\" is not being included in PDF file",
                        "TEXT-MCQ-INPUT-FIELD-WITHOUT-MAXLENGTH": "Cloze/Input field without \"Max Length\" defined in \"{{s}}\" - please open Text Field Properties dialog and re-confirm the properties or add a maxLength attribute in HTML sourcecode.",
                        "RICHTEXT-ACTIVED-AUTOPLOT":"The Table object in \"{{s}}\" has a target Table with actvated Richtext"
                    }
                }
            }
        }
    },
    "APPS": {
        "COMMON": {
            "LANGUAGE-SELECTION": {
                "LABEL": "Select language",
                "LANGUAGE-PLACEHOLDER": "Please select your language / Veuillez sélectionner votre langue / Seleccione el idioma",
                "LANGUAGE": {
                    "ENGLISH_US": "English",
                    "FRENCH_FR":  "Français",
                    "SPANISH_ES": "Español"
                }
            }
        }
    },
    "COMCHECK": {
        "INFO" : {
            "REQUIRED-INFO": "Required field must not be left blank"
        },
        "LABEL": "On-screen examination Compatibility Checker",
        "STEP": "Step {{currentStep}} of {{maxSteps}}",
        "USER-DATA": {
            "LABEL": "User details",
            "DESCRIPTION": [
                "The Compatibility Checker will identify whether this device meets the core requirements for running on-screen examination packages.",
                "Please fill in the details below and then <strong>Continue to Step {{nextStep}}</strong>.",
                "The IB will record the results of this check so please ensure that the school code is entered accurately."
            ],
            "INPUT-LABEL": {
                "NAME": "Name",
                "EMAIL": "Email",
                "SCHOOL-CODE": "School code"
            },
            "ERROR": {
                "REQUIRED-SCHOOL-CODE": "Please enter your school code",
                "VALID-MAIL": "Not a valid email address",
                "VALID-SCHOOL-CODE": "School code must be six digits, with leading zeroes if required (e.g., 001234)"
            }
        },
        "SYSTEM-COMP-CHECK": {
            "LABEL": "System check",
            "COUNT": "{{currentTestNum}} of {{testCount}}",
            "TEST-NAME":{
                "SysMem": "System Memory",
                "ScreenRes": "Screen Resolution",
                "DiskSpace": "Disk Space",
                "WriteResponse": "Saving Response File Locally",
                "OSVersion": "Operating System Version",
                "InternetConnection": "Internet Connectivity",
                "MediaServerTest": "Media Server Test",
                "VmDetection": "Virtual Machine Test"
            },
            "STATUS": {
                "PROCESSING": "Processing...",
                "PASSED": "Passed",
                "WARNING": "Warning",
                "FAILED": "Failed"
            },
            "STATUS-MESSAGE": {
                "PROCESSING": "Processing...",
                "PASSED": "This device is at, or above, the recommended specification for this check.",
                "WARNING": "This device is below the recommended specification, but satisfies the minimum specification requirement for this check. The on-screen examination will run, but the candidate may not have the optimum experience",
                "FAILED": "This device is below the minimum specification requirement for this check. The examination will not run as the user experience will be significantly affected."
            },
            "STATUS-COUNT": {
                "PASSED": "Pass {{count}}",
                "WARNING": "Warning {{count}}",
                "FAILED": "Failed {{count}}"
            }
        },
        "KEYBOARD-LAYOUT-COMP-CHECK":   {
            "KEYBOARD": "Keyboard",
            "LABEL": "Keyboard layout",
            "DESCRIPTION_1":[
                "Will this device be used to sit any of the Language and Literature examinations listed below?"
            ],
            "DESCRIPTION_2":[
                "Please indicate which Language and Literature examination(s) this device will be used for and then <strong>Continue to testing</strong>."
            ],
            "DESCRIPTION_3":[
                "This step will test your keyboard layout and input method, to ensure they behave as expected.",
                "Please enter some text in the applicable boxes below.",
                "This test will need to be completed for each language this device will be used for."
            ],
            "ACTIVATE-CHECKER":"",
            "ACTIVATE-CHECKER-LANG": {
                "ARABIC": "Arabic",
                "KOREAN": "Korean",
                "MANDARIN_CN": "Chinese (Simplified)",
                "MANDARIN_TW": "Chinese (Traditional)"
            },
            "ACTIVATE-CHECKER-BTN":"Yes",
            "DEACTIVATE-CHECKER-BTN":"No",
            "CONTINUE-TEST-BTN":"Continue to testing",
            "INSTRUCTION": {
                "SELECT-LANG": "",
                "TESTING-SELECTED-LANG": [
                    "Please indicate whether each check is passed or failed via the applicable buttons. You should <strong>Fail</strong> the test if the text in the input box does not appear/behave as expected.",
                    "Once completed, <strong>Continue to Step {{nextStep}}</strong>."
                ],
                "CHANGE-KEYBOARD-LAYOUT": "Click on this icon to change the current keyboard layout and input method. You should select the appropriate layout and input method for the language you are currently testing"
            },
            "CKEDITOR":{
                "PLACEHOLDER":"Please type something in {{lang}}"
            },
            "NO-LANGUAGES":"No languages selected",
            "ADD-LANG-BTN":"Add Language",
            "SUCCESS-BTN": "Pass",
            "FAILED-BTN": "Fail",
            "FAILED-MSG": "<p>You have indicated that the keyboard layout/input method check did not behave as expected for this language.</p><p>Please check that the device has the necessary keyboard/font installed and, if required, contact the IB for further support.</p>",
            "MODAL":{
                "HEADER":"Error",
                "INFO": "You must manually indicate whether all languages have passed or failed the keyboard layout test. The following languages do not yet show a result:",
                "RESULT-ERROR":"{{langName}}"
            }
        },
        "AUDIO-COMP-CHECK": {
            "LABEL": "Audio check",
            "DESCRIPTION":[
                "The audio clip below should start playing automatically. Check that the audio plays and can be heard clearly.",
                "Please <strong>Pass</strong> or <strong>Fail</strong> this check and you will automatically proceed to Step {{nextStep}}."
            ],
            "SUCCESS-BTN": "Pass",
            "FAILED-BTN": "Fail",
            "FAILED-MSG": "You have indicated that the audio file did not play correctly."
        },
        "VIDEO-COMP-CHECK": {
            "LABEL": "Video check",
            "DESCRIPTION": [
                "The video clip below should start playing automatically. Check that the video plays and can be seen and heard clearly.",
                "Please <strong>Pass</strong> or <strong>Fail</strong> this check and you will automatically proceed to Step {{nextStep}}."
            ],
            "SUCCESS-BTN": "Pass",
            "FAILED-BTN": "Fail",
            "FAILED-MSG": "You have indicated that the video did not play correctly."
        },
        "SUMMARY-COMP-CHECK": {
            "LABEL": "Results summary",
            "STATUS-PANEL-HEADER": {
                "PASSED": "Compatibility Checker Passed",
                "WARNING": "Compatibility Checker Passed with warnings",
                "FAILED": "Compatibility Checker Failed"
            },
            "STATUS-PANEL-DESCRIPTION": {
                "PASSED": [
                    "This system has met or exceeded all of the recommended system requirements for an optimum user experience.",
                    "Please ensure that the Compatibility Checker is run on all devices that will be used for the on-screen examinations."
                ],
                "WARNING": [
                    "This device has met or exceeded all of the minimum system requirements. However, in at least one case the recommended requirement has not been met. The device will run the on-screen examinations but with the potential that the user may not have an optimum experience.",
                    "Please ensure that the Compatibility Checker is run on all devices that will be used for the on-screen examinations."
                ],
                "FAILED": [
                    "This device has not met the minimum specification requirement in at least one category, or it has encountered an issue playing media. Therefore, it cannot be used to run on-screen examinations in its current state. Please contact the IB to discuss any issues arising from this compatibility check.",
                    "Please ensure that the Compatibility Checker is run on all devices that will be used for the on-screen examinations."
                ]
            },
            "PANEL-HEADER":        {
                "PASSED": "Passed",
                "WARNING": "Warning",
                "FAILED": "Failed",
                "ABORTED-TESTS":"Aborted tests"
            }
        },
        "UPLOAD-STATUS": {
            "TYPE": {
                "INIT": "Initialising upload of results",
                "PACK-RESPONSE": "Collating data",
                "UPLOAD": "Uploading results to the IB",
                "UPLOAD-PROGRESS": "[Upload Progress]",
                "OFFLINE-INIT": "Processing"
            },
            "MSG": {
                "PACK-RESPONSE-FAILED": "Pack response failed",
                "PACK-RESPONSE-SUCCESS": "Pack response success",
                "RESPONSE_INITIALIZED": "Response initialized",
                "RESPONSE_INIT_FAILED": "Response init failed",
                "UPLOAD-CONFIG-MISSING": "Upload config missing",
                "UPLOAD-INTERNET-CONNECTION": "Internet connection failed",
                "UPLOAD-SUCCESS": "These results have been successfully uploaded to the IB.",
                "USER-DATA-EMPTY": "User data is empty",
                "RESPONSE-READY": "Processing complete. You may now <strong>Quit</strong>."
            }
        },
        "QUIT-MODAL":   {
            "HEADER": "Quit",
            "INFO":   [
                "Are you sure you want to quit the Compatibility Checker?",
                "Click <strong>Cancel</strong> to return.",
                "Preparing results.",
                "Preparing results."
            ]
        },
        "BTN":                {
            "CONTINUE":   "Continue to Step {{nextStep}}",
            "QUIT":       "Quit",
            "CANCEL":     "Cancel",
            "REMOVE":     "Remove",
            "RETRY":      "Retry upload",
            "CLOSE":      "Close"
        }
    },
    "SPECIMEN-RESPONSE-UPLOAD": {
        "LABEL": "Student response upload",
        "FILENAME": "Filename",
        "BUTTON-CLOSE-SESSION": "Close session",
        "LOGIN": {
            "LABEL" : "Login",
            "ENTER-PASSWORD": "Enter password",
            "INVALID-LOGIN": "<strong>An incorrect password has been entered. Please try again.</strong>"
        },
        "SESSION": {
            "TITLE": "IB response file upload",
            "EXPIRED": "Your session has expired",
            "EXPIRED-TRY-AGAIN": "Please log in again to upload further response files.",
            "ERROR": "There is a problem with your session.",
            "ERROR-TRY-AGAIN": "Please log in again to upload further response files."
        },
        "IDENTIFICATION": {
            "LABEL" : "Identification",
            "FORM": {
                "NAME": "Please enter your name:",
                "EMAIL": "Please enter your email address:",
                "EMAIL-CONFIRM": "Please confirm your email address:",
                "SCHOOLCODE": "Please enter your school code:",
                "BUTTON-CONFIRM": "Confirm"
            },
            "FORM-PLACEHOLDER": {
                "NAME": "Name",
                "EMAIL": "Email",
                "SCHOOLCODE": "School code"
            },
            "FORM-VALIDATION": {
                "NAME": "Name required",
                "EMAIL-REQUIRED": "A valid email address is required",
                "EMAIL-DIVERGE": "Email addresses entered do not match.",
                "EMAIL-INVALID-FORMAT": "A valid email address is required",
                "SCHOOLCODE-REQUIRED": "Please enter your numerical school code.",
                "SCHOOLCODE-INVALID": "Please enter your numerical school code."
            },
            "INFO-BOX": {
                "MESSAGE": "The PDF download link will be sent to the email address entered at this stage"
            }
        },
        "UPLOAD": {
            "LABEL" : "Upload",
            "UPLOAD-BOX": {
                "MESSAGE": "Drag response files here or press ",
                "BUTTON-BROWSE": "Browse",
                "ONLY-RESPONSE-FILES": "Please only add <strong>.ibresponse</strong> file types",
                "REMAINING": {
                    "SINGLE-FILE": "1 file remaining:",
                    "MULTIPLE-FILES": "{{ files }} files remaining:"
                }
            },
            "QUEUE-BOX": {
                "SELECTED-FILES": "Selected files:",
                "REJECTED-FILES": "Rejected files:",
                "BUTTON-UPLOAD": "Upload"
            },
            "NO-IB-FILES": {
                "TITLE": "IB response file upload",
                "MESSAGE": "You have attempted to upload an invalid file type. Any non .ibresponse files will be excluded in the final processing."
            },
            "PROGRESS-BARS": {
                "OVERALL": "Uploading {{ s1 }}/{{ total }} .ibresponse file(s)."
            }
        },
        "PROGRESS": {
            "LABEL": "Progress"
        },
        "SUMMARY": {
            "LABEL" : "Summary",
            "NO-FILES": {
                "ATTEMPTED": "You attempted to upload {{ files }} response file(s).",
                "MESSAGE": "The response file(s) could not be uploaded.",
                "MORE-INFO": "Please try again later."
            },
            "SINGLE-FILE": {
                "ATTEMPTED": "You attempted to upload 1 response file.",
                "SUCCESS": "The response file has been uploaded successfully.",
                "MORE-INFO": "You will receive an email containing the PDF download link in approximately 30-60 minutes. The email will be sent to {{ email }}"
            },
            "MULTIPLE-FILES": {
                "ATTEMPTED": "You attempted to upload {{ files }} response files.",
                "SUCCESS": "<strong>{{ succededfiles }}</strong> files have been uploaded successfully.",
                "MORE-INFO": "You will receive an email containing the PDF download link in approximately 30-60 minutes. The email will be sent to {{ email }}"
            },
            "REJECTED": {
                "TITLE": "Rejected files",
                "FILENAME": "Filename"
            },
            "COULD-NOT-SAVE": "There is a problem. Please check your internet connection and try again."
        }
    },
    "NOT-AVAILABLE": "n/a",
    "DATE-FROM": "From:",
    "DATE-TO": "To:",
    "TIMEZONE-UTC": "UTC",
    DIALOGS_ERROR: "Error",
    DIALOGS_ERROR_MSG: "An unknown error has occurred.",
    DIALOGS_CLOSE: "Close",
    DIALOGS_PLEASE_WAIT: "Please wait",
    DIALOGS_PLEASE_WAIT_ELIPS: "Please wait...",
    DIALOGS_PLEASE_WAIT_MSG: "Waiting for operation to complete.",
    DIALOGS_PERCENT_COMPLETE: "% complete",
    DIALOGS_NOTIFICATION: "Notification",
    DIALOGS_NOTIFICATION_MSG: "Unknown application notification.",
    DIALOGS_CONFIRMATION: "Confirmation",
    DIALOGS_CONFIRMATION_MSG: "Confirmation required.",
    DIALOGS_OK: "OK",
    DIALOGS_YES: "Yes",
    DIALOGS_NO: "No"
};
